const THUMB_CACHE_KEY   = "compare:thumbs";
const TITLES_CACHE_KEY  = "compare:titles";
const SWATCH_MF_KEY     = "select_stitcher";

const DEFAULT_EXCLUDED_HANDLES = ["murphy-ski-suit"];
const DEFAULT_COMPARE_COLLECTIONS = [
  { title: "Base Layers", handle: "base-layers" },
  { title: "Snow Jackets", handle: "snow-jackets" },
  { title: "Snow Pants", handle: "snow-pants" },
];

// ===== Shared localStorage helpers =====
const ACTIVE_COLLECTION_KEY = "compare:active_collection";
const WORKING_KEY           = "compare:handles:working";
const handlesKeyFor = (h) => `compare:handles:${String(h||"").toLowerCase()}`;
const readJSON  = (k, fb) => { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : fb; } catch { return fb; } };
const writeJSON = (k, v)   => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };

// === Global "preseleccionados" (PLP) =========================================
const ACTIVE_GLOBAL_KEY = "compare:handles:active";
function _readGlobalActives() { return readJSON(ACTIVE_GLOBAL_KEY, []); }
function _writeGlobalActives(arr) { writeJSON(ACTIVE_GLOBAL_KEY, _uniq(arr || [])); }
function _clearGlobalActives() { try { localStorage.removeItem(ACTIVE_GLOBAL_KEY); } catch {} }


const COMPARE_WORKING_KEY = "compare:handles:working"; // comparison-page only
const MODE_PREFIX = "compare:mode:";

function _readCollectionMode(handle){
  try { return localStorage.getItem(`${MODE_PREFIX}${String(handle||"").toLowerCase()}`) || ""; } catch { return ""; }
}
function _writeCollectionMode(handle, mode){
  try { localStorage.setItem(`${MODE_PREFIX}${String(handle||"").toLowerCase()}`, mode === "full" ? "full" : "black"); } catch {}
}


// Treat "black" and common abbreviations; adjust as needed
const DEFAULT_COLOR_SLUG = "black";

function _isHandleColor(handle, color = DEFAULT_COLOR_SLUG){
  if (!handle) return false;
  const c = String(color).trim().toLowerCase();
  // match "-black", "_black", "black-" or end; also accept "-blk"
  const re = c === "black"
    ? /(^|[-_])(?:black|blk)(?=$|[-_])/i
    : new RegExp(`(^|[-_])(${c})(?=$|[-_])`, "i");
  return re.test(String(handle));
}

function _filterHandlesByColor(handles = [], color = DEFAULT_COLOR_SLUG){
  const blacks = (handles || []).filter(h => _isHandleColor(h, color));
  return blacks.length ? blacks : [];
}

const _uniq = (arr) => Array.from(new Set((arr || []).filter(Boolean)));

function _clearPdpSeed() {
  try {
    sessionStorage.removeItem('compare:pdp:seeds');
    sessionStorage.removeItem('compare:pdp:refCol');
    sessionStorage.removeItem('compare:pdp:sticky');
    sessionStorage.removeItem('compare:seed');
    sessionStorage.removeItem('compare:from');
  } catch {}

  try {
    const keys = Object.keys(localStorage);
    for (const k of keys) {
      if (k.startsWith('compare:pdp:handles:')) localStorage.removeItem(k);
      if (k.startsWith('compare:pdp:picks:'))   localStorage.removeItem(k);
    }
  } catch {}

  try {
    const u = new URL(location.href);
    if (u.searchParams.has('seed')) {
      u.searchParams.delete('seed');
      history.replaceState(history.state, '', u.toString());
    }
  } catch {}
}

function _clearPdpSticky() {
  try {
    sessionStorage.removeItem('compare:pdp:sticky');
    sessionStorage.removeItem('compare:pdp:refCol');
    sessionStorage.removeItem('compare:seed');
    sessionStorage.removeItem('compare:pdp:seeds');
    sessionStorage.removeItem('compare:pdp:ordered');
  } catch {}
}

function _clearAllSavedPicks(exceptHandle = null){
  try {
    const cols = (window.__CMP_COLS__ ||
      (Array.isArray((this?.state||{}).collections) ? this.state.collections : []) ||
      []).map(c => c && c.handle).filter(Boolean);

    const allHandles = cols.length ? cols : ["snow-jackets","snow-pants","base-layers"];
    allHandles.forEach(h => {
      if (!exceptHandle || h !== exceptHandle) {
        localStorage.removeItem(`compare:handles:${h}`);
      } else {
        localStorage.removeItem(`compare:handles:${h}`);
      }
    });

    localStorage.removeItem("compare:handles:working");
  } catch {}
}

function _safeRemoveLS(k){ try { localStorage.removeItem(k); } catch {} }

function _readPDPSeedFromContext(){
  try {
    const from = sessionStorage.getItem("compare:from");
    const ref  = (sessionStorage.getItem("compare:pdp:refCol") || "").toLowerCase();
    const arr  = JSON.parse(sessionStorage.getItem("compare:pdp:seeds") || "[]");
    const seeds = Array.from(new Set((arr || []).map(s => String(s).toLowerCase()).filter(Boolean)));
    return { fromPDP: from === "pdp" && !!ref && seeds.length > 0, refCol: ref, seeds };
  } catch { return { fromPDP:false, refCol:"", seeds:[] }; }
}

function _clearPLPActivesOnly(state){
  try {
    localStorage.removeItem("compare:handles:working");
    localStorage.removeItem("compare:handles");

    const list = (state?.collections || []).map(c => c.handle).filter(Boolean);
    list.forEach(h => {
      const k = (typeof handlesKeyForCollection === "function")
        ? handlesKeyForCollection(h)
        : `compare:handles:${h}`;
      localStorage.removeItem(k);
    });

    localStorage.removeItem("compare:last_source");
  } catch {}
}

// === PDP vs PLP storage namespaces ===
const PDP_PICKS_PREFIX = "compare:pdp:picks:";
const pdpKeyFor = (h) => `${PDP_PICKS_PREFIX}${String(h||"").toLowerCase()}`;

function _readPdpHandlesForCollection(colHandle){
  if (!colHandle) return [];
  try {
    const raw = localStorage.getItem(pdpKeyFor(colHandle));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.from(new Set((Array.isArray(arr) ? arr : []).filter(Boolean)));
  } catch { return []; }
}

function _writePdpHandlesForCollection(colHandle, arr){
  if (!colHandle) return;
  const next = Array.from(new Set((arr||[]).filter(Boolean)));
  try { localStorage.setItem(pdpKeyFor(colHandle), JSON.stringify(next)); } catch {}
}

function _stickyPdpInfo() {
  try {
    const from = (sessionStorage.getItem('compare:from') || '').toLowerCase();
    if (from === 'plp') return { sticky: false, refCol: '' };

    const sticky = sessionStorage.getItem('compare:pdp:sticky') === '1';
    const refCol = (sessionStorage.getItem('compare:pdp:refCol') || '').toLowerCase();
    return { sticky, refCol };
  } catch {
    return { sticky: false, refCol: '' };
  }
}


function _clearPLPOnly(state){
  try {
    localStorage.removeItem("compare:handles:working");
    localStorage.removeItem("compare:handles");

    const list = (state?.collections || []).map(c => c.handle).filter(Boolean);
    list.forEach(h => localStorage.removeItem(`compare:handles:${h}`));
  } catch {}
}

function _clearPDPOnly() {
  try {
    sessionStorage.removeItem('compare:pdp:refCol');
    sessionStorage.removeItem('compare:pdp:seeds');
    sessionStorage.removeItem('compare:pdp:sticky');
    sessionStorage.removeItem('compare:seed');
    sessionStorage.removeItem('compare:from');
  } catch {}
  try {
    localStorage.removeItem('compare:handles:working');
  } catch {}
}

function _clearAllPLPyPDP(state){
  _clearPLPOnly(state);
  _clearPDPOnly();
}

const _COMPARE_DEBUG = (() => {
  try {
    const url = new URL(location.href);
    if (url.searchParams.has("debug_compare")) return true;
    return localStorage.getItem("compare:debug") === "1";
  } catch { return false; }
})();
const log = (...args) => { try { console.log(...args); } catch {} };

const readActiveCollection = () => {
  try { return JSON.parse(localStorage.getItem(ACTIVE_COLLECTION_KEY)) || null; }
  catch { return null; }
};

const unsizeImage = (u) => {
  if (!u) return u;
  return u.replace(/(_\d+x\d*|_\d+x)(?=\.[a-z]{3,4}(\?|$))/i, "");
};

const handlesKeyForCollection = (h) => `compare:handles:${h}`;

// ---- URL helpers ----
function readActiveCollectionFromURL() {
  try {
    const u = new URL(location.href);
    const handle = u.searchParams.get("refCol");
    if (!handle) return null;
    return { handle, title: handle.replace(/-/g, " ").replace(/\b\w/g, s => s.toUpperCase()) };
  } catch { return null; }
}

function cameFromCollectionPage() {
  try {
    if (readActiveCollectionFromURL()?.handle) return true;

    if (!document.referrer) return false;
    const ref = new URL(document.referrer);
    return /\/collections\/[^/?#]+/i.test(ref.pathname);
  } catch { return false; }
}


function writeActiveCollectionToURL({ handle }, { push = true } = {}) {
  if (!handle) return;
  try {
    const u = new URL(location.href);
    u.searchParams.set("refCol", handle);
    if (push) history.pushState({ refCol: handle }, "", u.toString());
    else history.replaceState({ refCol: handle }, "", u.toString());
  } catch {}
}

function currentCollectionHandleFromPath() {
  try {
    const m = location.pathname.match(/\/collections\/([^/?#]+)/i);
    return m ? { handle: m[1] } : null;
  } catch { return null; }
}

(function normalizeThumbCache(){
  try {
    const map = readThumbs();
    let changed = false;
    for (const k in map) {
      const v = map[k];
      const u = unsizeImage(v);
      if (u && u !== v) { map[k] = u; changed = true; }
    }
    if (changed) writeThumbs(map);
  } catch {}
})();

function ensureActiveCollectionFromReferrer() {
  try {
    if (!document.referrer) return;
    const ref = new URL(document.referrer);
    const m = ref.pathname.match(/\/collections\/([^/?#]+)/i);
    if (!m) return;

    const handle = m[1];
    const known  = DEFAULT_COMPARE_COLLECTIONS.find(c => c.handle === handle);
    const title  = known
      ? known.title
      : handle.replace(/-/g, " ").replace(/\b\w/g, s => s.toUpperCase());

    localStorage.setItem(
      ACTIVE_COLLECTION_KEY,
      JSON.stringify({ handle, title })
    );
    log("[compare] active collection (from referrer):", { handle, title });
  } catch {}
}

function ensureActiveCollectionFromURLOrReferrer() {
  const fromURL = readActiveCollectionFromURL();
  if (fromURL?.handle) {
    try { localStorage.setItem(ACTIVE_COLLECTION_KEY, JSON.stringify(fromURL)); } catch {}
    return;
  }

  ensureActiveCollectionFromReferrer();
}

const readTitles = () => { try { return JSON.parse(localStorage.getItem(TITLES_CACHE_KEY)) || {}; } catch { return {}; } };
const writeTitles = (m) => { try { localStorage.setItem(TITLES_CACHE_KEY, JSON.stringify(m)); } catch {} };

const readThumbs = () => { try { return JSON.parse(localStorage.getItem(THUMB_CACHE_KEY)) || {}; } catch { return {}; } };
const writeThumbs = (m) => { try { localStorage.setItem(THUMB_CACHE_KEY, JSON.stringify(m)); } catch {} };

const sizeImage = (url, size = "190x") =>
  url && /_\d+x\./.test(url) ? url : url.replace(/(\.[a-z]+)(\?.*)?$/i, `_${size}$1$2`);


// ===== web component ==========================================================
class CompareProducts extends HTMLElement {
  constructor() {
    super();
    this.state = {
      maxColumns: 3,
      columns: [],
      productsByHandle: {},
      seedByHandle: {},
      seedOrder: [],
      features: [],
      collectionDefaultsByHandle: {},
      collectionCatalog: {},
      _disabledHandles: new Set(),
      onCollectionPage: !!currentCollectionHandleFromPath(), 
    };

    this._bootDone = false;

    // === Section JSON Data (from <script js-data>) ===
    try {
      const dataEl =
        this.querySelector('script[type="application/json"][js-data]') ||
        this.closest('section')?.querySelector('script[type="application/json"][js-data]');
      if (dataEl) {
        const parsed = JSON.parse(dataEl.textContent || "{}");

        const sectionTitle = (parsed?.title || "").trim();
        const sectionFeatures = Array.isArray(parsed?.features) ? parsed.features : [];

        this.state.section = { title: sectionTitle, features: sectionFeatures, text: sectionTitle };
        // this.state.section = { title: sectionTitle, features: sectionFeatures };
        // this.state.text = sectionTitle;
        // if (!this.state.features?.length) this.state.features = sectionFeatures;
      }
    } catch (err) {
      console.warn("[compare-products] Error parsing products", err);
    }

    this._prevHandles = []; 
    this._moCache = Object.create(null);

    this._switchingCollection = null;
    this._catalogRequestInFlight = false;

    this._onCompareChange = this._onCompareChange.bind(this);
    this._onStorage       = this._onStorage.bind(this);

    this._headingResizeHandler = () => this._scheduleHeadingSync();
    this._headingRaf = null;
    this._fontListener = null;


    const csv = (this.dataset && this.dataset.excludeHandles) || "";
    this.excludedHandles = new Set(
      (csv ? csv.split(",") : DEFAULT_EXCLUDED_HANDLES)
        .map(s => String(s || "").trim().toLowerCase())
        .filter(Boolean)
    );

    // helpers
    this._isExcluded = (h) => this.excludedHandles.has(String(h || "").toLowerCase());
    this._filterOutExcluded = (arr = []) => arr.filter(h => !this._isExcluded(h));

  }

  connectedCallback() {
    try {
      const qs = new URLSearchParams(location.search);
      let source = (qs.get('from') || '').toLowerCase();

      if (!source) {
        try {
          const r = document.referrer ? new URL(document.referrer) : null;
          if (r && /\/collections\/[^/?#]+/i.test(r.pathname)) source = 'plp';
          else if (r && /\/products\/[^/?#]+/i.test(r.pathname)) source = 'pdp';
        } catch {}
      }

      if (source === 'plp') {
        _clearPdpSeed();
        try { localStorage.removeItem('compare:handles:working'); } catch {}
        sessionStorage.setItem('compare:from', 'plp');
      } else if (source === 'pdp') {
        _clearPLPOnly(this.state);
        try { localStorage.removeItem('compare:handles:working'); } catch {}
        sessionStorage.setItem('compare:from', 'pdp');
      } else {
        const pdpSticky = (() => { try { return sessionStorage.getItem('compare:pdp:sticky') === '1'; } catch { return false; }})();
        const workingNow = (() => { try { return JSON.parse(localStorage.getItem('compare:handles:working')||'[]'); } catch { return []; }})();
        const hasAnyPlpPicks = (() => {
          try {
            const cols = (this.state?.collections || []).map(c => c.handle).filter(Boolean);
            return cols.some(h => {
              const raw = localStorage.getItem(`compare:handles:${h}`);
              if (!raw) return false;
              try { return (JSON.parse(raw)||[]).length > 0; } catch { return false; }
            });
          } catch { return false; }
        })();

        if (pdpSticky && !hasAnyPlpPicks && (!workingNow || workingNow.length === 0)) {
          _clearPDPOnly();
        }
      }
    } catch {}


    this.addEventListener("click", this._onRootClick, true); // capture=true
    window.addEventListener("compare_change", this._onCompareChange);
    window.addEventListener("storage", this._onStorage);


    try {
      const qsFrom = (new URLSearchParams(location.search).get('from') || '').toLowerCase();
      if (qsFrom !== 'pdp') {
        sessionStorage.removeItem('compare:pdp:refCol');
        sessionStorage.removeItem('compare:pdp:seeds');
        sessionStorage.removeItem('compare:pdp:sticky');
      }
    } catch {}


    try {
      const work = localStorage.getItem("compare:handles:working");
      if (!work) {
        const plpRaw = localStorage.getItem("compare:handles");
        if (plpRaw) {
          localStorage.setItem("compare:handles:working", plpRaw);
          try { this._writeHandles(JSON.parse(plpRaw)); } catch {}
        }
      }
    } catch {}

    try {
      const wRaw = localStorage.getItem(COMPARE_WORKING_KEY);
      if (wRaw) localStorage.setItem(COMPARE_WORKING_KEY, JSON.stringify(_uniq(JSON.parse(wRaw)||[])));

      const cols = (this.state.collections || []).map(c => c.handle).filter(Boolean);
      cols.forEach(h => {
        const k = handlesKeyForCollection(h);
        const v = localStorage.getItem(k);
        if (v) localStorage.setItem(k, JSON.stringify(_uniq(JSON.parse(v)||[])));
      });
    } catch {}

    try { console.log("[compare] component connected"); } catch {}
    this._booting = true;
    this._whenSeedReady().then(async () => {
      this._deferFirstPaint = true;
      this._suppressEvents  = true;

      ensureActiveCollectionFromURLOrReferrer();

      let pdpSeeds = [];
      let pdpRefCol = "";
      let fromPDP = false;

      try {
        const qs = new URLSearchParams(location.search);
        const fromQS = (qs.get("from") || "").toLowerCase();
        const refQS  = (qs.get("refCol") || "").toLowerCase();
        const seedQS = (qs.get("seed") || "").trim();

        if (fromQS === "pdp" && refQS) {
          fromPDP   = true;
          pdpRefCol = refQS;

          const ssSeeds = (() => { try { return sessionStorage.getItem("compare:seed") || ""; } catch { return ""; }})();
          const raw = seedQS || ssSeeds;
          pdpSeeds = Array.from(new Set(
            raw.split(",").map(s => s.trim().toLowerCase()).filter(Boolean)
          ));
        }
      } catch {}

      this._parseSeed();

      try {
        const qs     = new URLSearchParams(location.search);
        const fromQS = (qs.get("from")   || "").toLowerCase();
        let   refCol = (qs.get("refCol") || "").toLowerCase();

        const fromReferrerPLP = (() => {
          try {
            if (!document.referrer) return false;
            const r = new URL(document.referrer);
            return /\/collections\/[^/?#]+/i.test(r.pathname);
          } catch { return false; }
        })();

        if (!refCol) refCol = (readActiveCollection()?.handle || "").toLowerCase();

        const cameFromPLP = (fromQS === "plp") || fromReferrerPLP;

        if (cameFromPLP && refCol) {
          _clearPdpSeed();
          const incomingWorking = (() => { try { return JSON.parse(localStorage.getItem(COMPARE_WORKING_KEY) || "[]"); } catch { return []; }})();
          const incomingLegacy  = (() => { try { return JSON.parse(localStorage.getItem("compare:handles") || "[]"); } catch { return []; }})();
          const incomingPicks   = Array.from(new Set([...(incomingWorking||[]), ...(incomingLegacy||[])]
            .map(h => String(h||"").toLowerCase()).filter(Boolean)));

          try {
            localStorage.setItem(ACTIVE_COLLECTION_KEY, JSON.stringify({
              handle: refCol, title: refCol.replace(/-/g, " ").replace(/\b\w/g, s => s.toUpperCase())
            }));
            const u = new URL(location.href);
            u.searchParams.set("refCol", refCol);
            history.replaceState({ refCol }, "", u.toString());
          } catch {}

          try { localStorage.setItem("compare:last_source", "plp"); } catch {}

          try { localStorage.removeItem(COMPARE_WORKING_KEY); } catch {}


          let full = await this._fetchAllProductHandlesInCollection(refCol);
          full = Array.from(new Set((full || []).map(h => String(h||"").toLowerCase()).filter(Boolean)));
          if (typeof this._isExcluded === "function") full = full.filter(h => !this._isExcluded(h));

          if (this._shouldUseBlackOnly(handle)) {
            const blacks = _filterHandlesByColor(full, DEFAULT_COLOR_SLUG);
            if (blacks.length) full = blacks;
          }

          const maxCols = this.state.maxColumns;

          const incoming = (incomingPicks || [])
            .map(h => String(h || "").toLowerCase())
            .filter(h => full.includes(h));

          let restOfFull = full.filter(h => !incoming.includes(h));
          restOfFull     = _filterHandlesByColor(restOfFull, DEFAULT_COLOR_SLUG);

          const ordered = Array.from(new Set([ ...incoming, ...restOfFull ]));

          let chosen;
          if (incoming.length) {
            chosen = ordered.slice(0, maxCols);
          } else {
            chosen = ordered.length ? [ordered[0]] : [];
          }

          if (chosen.length) this._writeHandlesForCollection(refCol, chosen);

          _writeCollectionMode(refCol, "black");

          this.state._disabledHandles = new Set(ordered.filter(h => !chosen.includes(h)));

          await this._commitOrdered(ordered, { chosen, silent: true });
          await this._ensureThumbsFor(ordered);

          this._syncFromStorage();
          this._renderColumnsOnly();

          this._bootDone = true;
        }
      } catch (e) { console.warn("[compare] PLP bootstrap failed", e); }

      if (!this._bootDone) try  {
        const qs     = new URLSearchParams(location.search);
        const fromQ  = (qs.get("from")   || "").toLowerCase();
        const refQ   = (qs.get("refCol") || "").toLowerCase();
        const fromSS = (() => { try { return (sessionStorage.getItem('compare:from') || "").toLowerCase(); } catch { return ""; } })();
        const fromReferrerPLP = cameFromCollectionPage();

        const nowActive = readActiveCollection();
        if (nowActive?.handle) {
          await this._fetchCollectionCatalog(nowActive.handle);

          const handle = nowActive.handle;
          const saved = (this._readHandlesForCollection(handle) || []).map(h => String(h||"").toLowerCase());

          const isPLP = (fromQ === "plp") || (fromSS === "plp") || fromReferrerPLP;
          const treatAsPLP = isPLP && (!refQ || refQ === handle) && saved.length > 0;
          if (treatAsPLP) _writeCollectionMode(handle, "full");

          let full = this.state.collectionDefaultsByHandle?.[handle];
          if (!Array.isArray(full) || !full.length) {
            full = this._normalizeFull(await this._fetchAllProductHandlesInCollection(handle));
          } else {
            full = this._normalizeFull(full);
          }

          if (!treatAsPLP && this._shouldUseBlackOnly(handle)) {
            const blacks = _filterHandlesByColor(full, DEFAULT_COLOR_SLUG);
            if (blacks.length) full = blacks;
          }

          const chosen = saved.length
            ? saved.filter(h => full.includes(h)).slice(0, this.state.maxColumns)
            : (full.length ? [full[0]] : []);

          let rest = full.filter(h => !chosen.includes(h));
          if (!treatAsPLP) rest = _filterHandlesByColor(rest, DEFAULT_COLOR_SLUG);

          const ordered = Array.from(new Set([...chosen, ...rest]));

          if (chosen.length) this._writeHandlesForCollection(handle, chosen);
          this.state._disabledHandles = new Set(rest);
          await this._commitOrdered(ordered, { chosen, silent: true });
        }

        try { 
          sessionStorage.setItem('compare:from','plp');
          localStorage.setItem('compare:last_source','plp');
        } catch {}
      } catch {}

      
      if (fromPDP && pdpRefCol && pdpSeeds.length) {
        try {
          localStorage.removeItem("compare:handles:working");
          localStorage.removeItem("compare:handles");
          localStorage.removeItem("compare:last_source");

          const cols = (this.state.collections || []).map(c => c.handle).filter(Boolean);
          cols.forEach(h => {
            try { localStorage.removeItem(`compare:handles:${h}`); } catch {}
          });
        } catch {}

        this._pdpSession = true;

        try {
          localStorage.setItem(
            typeof ACTIVE_COLLECTION_KEY !== "undefined" ? ACTIVE_COLLECTION_KEY : "compare:active_collection",
            JSON.stringify({ handle: pdpRefCol, title: pdpRefCol.replace(/-/g, " ").replace(/\b\w/g, s => s.toUpperCase()) })
          );
          const u = new URL(location.href);
          u.searchParams.set("refCol", pdpRefCol);
          history.replaceState({ refCol: pdpRefCol }, "", u.toString());
        } catch {}

        await this._fetchCollectionCatalog(pdpRefCol);
        let full = this._normalizeFull(await this._fetchAllProductHandlesInCollection(pdpRefCol));
        full = full.filter(h => !this._isExcluded?.(h));

        const actives = pdpSeeds.filter(h => full.includes(h)).slice(0, this.state.maxColumns);
        const rest    = full.filter(h => !actives.includes(h));
        const ordered = [...actives, ...rest];

        this.state._disabledHandles = new Set(rest);
        await this._commitOrdered(ordered, { chosen: actives, silent: true });
        this._bootDone = true;


        try {
          sessionStorage.removeItem('compare:pdp:sticky');
          sessionStorage.removeItem('compare:pdp:seeds');
          sessionStorage.removeItem('compare:pdp:ordered');
        } catch {}

        try { sessionStorage.removeItem("compare:seed"); } catch {}
      }


      if (!this._bootDone) {
        const nowActive = readActiveCollection();
        if (nowActive?.handle) {

          if (fromPDP) {
            // console.log('[compare] skip tray rebuild — using PDP seed');
          } else {
            const activeHandle = nowActive.handle;

            await this._fetchCollectionCatalog(activeHandle);

            const saved = (this._readHandlesForCollection(activeHandle) || []).map(h => String(h||"").toLowerCase());
            let full;

            const useFull = !this._shouldUseBlackOnly(activeHandle);
            full = this._normalizeFull(
              await (useFull
                ? this._fetchAllProductHandlesInCollection(activeHandle)
                : this._fetchCollectionDefaultHandles(activeHandle))
            );

            const chosen = saved.length
              ? saved.filter(h => full.includes(h)).slice(0, this.state.maxColumns)
              : (full.length ? [full[0]] : []);

            let rest = full.filter(h => !chosen.includes(h));
            rest = _filterHandlesByColor(rest, DEFAULT_COLOR_SLUG);

            const ordered = Array.from(new Set([...chosen, ...rest]));

            if (chosen.length) this._writeHandlesForCollection(activeHandle, chosen);
            this.state._disabledHandles = new Set(rest);
            await this._commitOrdered(ordered, { chosen, silent: true });


            if (saved.length) this._writeHandlesForCollection(activeHandle, chosen);
            this.state._disabledHandles = new Set(rest);
            await this._commitOrdered(ordered, { chosen, silent: true });

          }
        }
      }

      this._applyResponsiveColumns();
      this._mqHandler = () => this._applyResponsiveColumns();
      window.addEventListener("resize", this._mqHandler);
      if (this._headingResizeHandler) {
        window.addEventListener("resize", this._headingResizeHandler);
      }
      if (document?.fonts) {
        if (document.fonts.addEventListener && !this._fontListener) {
          this._fontListener = () => this._scheduleHeadingSync();
          document.fonts.addEventListener("loadingdone", this._fontListener);
        }
        if (document.fonts.ready) {
          document.fonts.ready.then(() => this._scheduleHeadingSync());
        }
      }

      {
        const active = readActiveCollection();
        if (!active?.handle && Array.isArray(this.state.collections) && this.state.collections.length) {
          const first = this.state.collections[0];
          try {
            localStorage.setItem(
              typeof ACTIVE_COLLECTION_KEY !== "undefined" ? ACTIVE_COLLECTION_KEY : "compare:active_collection",
              JSON.stringify({ handle: first.handle, title: first.title })
            );
          } catch {}
          writeActiveCollectionToURL({ handle: first.handle }, { push: false });
        }
      }

      {
        const nowActive = readActiveCollection();
        if (nowActive?.handle) {
          await this._fetchCollectionCatalog(nowActive.handle);
        }
      }

      {
        const handlesNow     = this._readHandles();
        const onCollectionPg = !!currentCollectionHandleFromPath();
        const arrivedFromCol = cameFromCollectionPage();
        const stickyRefCol   = (() => { try { return sessionStorage.getItem('compare:pdp:refCol') || ''; } catch { return ''; }})();
        const stickyPdpSeed  = (() => { try { return sessionStorage.getItem('compare:pdp:sticky') === '1'; } catch { return false; }})();
        const activeHandle   = readActiveCollection()?.handle || '';

        this._rehydrateDisabledFromLS();

        {
          const hasAnyCollectionPicks = (() => {
            try {

              return DEFAULT_COMPARE_COLLECTIONS.some(c => {
                const k = `compare:handles:${c.handle}`;
                const v = localStorage.getItem(k);
                if (!v) return false;
                try { return (JSON.parse(v) || []).length > 0; } catch { return false; }
              });
            } catch { return false; }
          })();

          const workingNow = (() => {
            try { return JSON.parse(localStorage.getItem('compare:handles:working')) || []; } catch { return []; }
          })();

          const stickyPdp = (() => {
            try { return sessionStorage.getItem('compare:pdp:sticky') === '1'; } catch { return false; }
          })();

          if (!hasAnyCollectionPicks && (!workingNow || workingNow.length === 0) && !stickyPdp) {
            console.log('[compare] No previous picks → pre-seeding ALL collections to defaults');
            await Promise.all(
              DEFAULT_COMPARE_COLLECTIONS.map(async (c) => {
                try {
                  const full = await this._fetchCollectionDefaultHandles(c.handle); // “black-only” predefinidos
                  const chosen = full.length ? [full[0]] : [];
                  this._writeHandlesForCollection(c.handle, chosen);
                  _writeCollectionMode(c.handle, "black");
                } catch (e) {
                  console.warn('[compare] failed to pre-seed defaults for', c.handle, e);
                }
              })
            );

            const nowActive = readActiveCollection();
            const activeHandle = nowActive?.handle || DEFAULT_COMPARE_COLLECTIONS[0]?.handle || '';
            if (activeHandle) {
              try {
                const full  = await this._fetchCollectionDefaultHandles(activeHandle);
                const act   = full.length ? [full[0]] : [];
                const rest  = full.filter(h => !act.includes(h));
                const order = [...act, ...rest];

                this._writeHandles(order);
                this.state._disabledHandles = new Set(rest);
                _writeCollectionMode(activeHandle, "black");
              } catch (e) {
                console.warn('[compare] failed to seed working for', activeHandle, e);
              }
            }
          }
        }


        if ((!handlesNow || handlesNow.length === 0) &&
          activeHandle &&
          !onCollectionPg &&
          (arrivedFromCol || !handlesNow || handlesNow.length === 0) &&
          !(stickyPdpSeed && stickyRefCol && activeHandle === stickyRefCol)) {
          await this._applyCollectionDefaults(readActiveCollection().handle, { softDisableAll: true });
        } else {
          this._syncFromStorage();
          this._rehydrateDisabledFromLS();
        }
      }

      if (!this._bootDone) {
         this._syncFromStorage();
          await this._ensureData();
          await this._ensureThumbsFor(this._readHandles());
          this._render();
      }

      this._deferFirstPaint = false;
      this._suppressEvents  = false;
      this._booting = false;

      this._ensureThumbsFor(this._readHandles());

      this._ro = new ResizeObserver(() => this._normalizeFeatureHeights());
      this._ro.observe(this);

      window.addEventListener("popstate", () => {
        const fromURL = readActiveCollectionFromURL();
        const current = readActiveCollection();
        if (fromURL?.handle && fromURL.handle !== current?.handle) {
          try {
            localStorage.setItem(
              typeof ACTIVE_COLLECTION_KEY !== "undefined" ? ACTIVE_COLLECTION_KEY : "compare:active_collection",
              JSON.stringify(fromURL)
            );
          } catch {}
          this._onCollectionChip(fromURL.handle, fromURL.title || "");
        }
      });

      window.addEventListener('pagehide', () => {
        try {
          if (this._pdpSession) {
            sessionStorage.removeItem('compare:from');
            sessionStorage.removeItem('compare:pdp:refCol');
            sessionStorage.removeItem('compare:pdp:seeds');
            sessionStorage.removeItem('compare:pdp:ordered');
            this._pdpSession = false;
          }
        } catch {}
      });

      this._debugTray?.("boot", { handle: (readActiveCollection()?.handle || "") });
    });
  }

  _onRootClick (e) {
    const rm = e.target.closest("[data-remove]");
    if (rm && this.contains(rm)) {
      e.preventDefault();
      const h = rm.getAttribute("data-handle") || "";
      if (h) this._onRemoveChip(h);
      return;
    }

    const wasTrayItem = e.target.closest(".compare-products__tray-item");
    if (wasTrayItem && this.contains(wasTrayItem)) {
      return;
    }

    const dashBtn = e.target.closest(".compare-products__dash");
    if (dashBtn && this.contains(dashBtn)) {
      e.preventDefault();
      const dashCol = dashBtn.closest(".compare-products__col");
      if (!dashCol) return;

      const idx = parseInt(dashBtn.getAttribute("data-gallery-idx"), 10);
      const handle = dashCol.getAttribute("data-handle") || "";
      const product = this.state.productsByHandle[handle];
      if (!product) return;

      const activeHandle = (product.selected?.handle || product.handle || "").trim();

      this._ensureGalleryForHandle(activeHandle).then((gallery) => {
        if (!Array.isArray(gallery) || !gallery[idx]) return;

        const mediaImg  = dashCol.querySelector(".compare-products__media img");
        const mediaLink = dashCol.querySelector(".compare-products__media a.compare-products__image");
        if (mediaImg) {
          mediaImg.removeAttribute("srcset");
          mediaImg.removeAttribute("data-srcset");
          mediaImg.setAttribute("src", gallery[idx]);
        }
        if (mediaLink) {
          const keepUrl = (product.selected?.url || product.url || `/products/${handle}`);
          mediaLink.setAttribute("href", keepUrl);
        }

        product.selected = Object.assign({}, product.selected, { gallery_idx: idx });

        dashCol.querySelectorAll(".compare-products__dash").forEach((el) => {
          const i = Number(el.getAttribute("data-gallery-idx"));
          const on = i === idx;
          el.classList.toggle("active", on);
          el.setAttribute("aria-current", on ? "true" : "false");
        });
      });
      return;
    }

    const navBtn = e.target.closest("[data-gallery-prev],[data-gallery-next]");
    if (navBtn && this.contains(navBtn)) {
      e.preventDefault();

      const navCol  = navBtn.closest(".compare-products__col");
      if (!navCol) return;

      const handle  = navCol.getAttribute("data-handle") || "";
      const product = this.state.productsByHandle[handle];
      if (!product) return;

      const activeHandle = (product.selected?.handle || product.handle || "").trim();

      this._ensureGalleryForHandle(activeHandle).then((gallery) => {
        if (!Array.isArray(gallery) || !gallery.length) return;

        const curr = (typeof product.selected?.gallery_idx === "number")
          ? product.selected.gallery_idx
          : 0;

        const dir = navBtn.hasAttribute("data-gallery-prev") ? -1 : 1;
        let nextIdx = curr + dir;
        if (nextIdx < 0) nextIdx = gallery.length - 1;
        if (nextIdx >= gallery.length) nextIdx = 0;

        const mediaImg  = navCol.querySelector(".compare-products__media img");
        const mediaLink = navCol.querySelector(".compare-products__media a.compare-products__image");
        if (mediaImg) {
          mediaImg.removeAttribute("srcset");
          mediaImg.removeAttribute("data-srcset");
          mediaImg.setAttribute("src", gallery[nextIdx]);
        }
        if (mediaLink) {
          const keepUrl = (product.selected?.url || product.url || `/products/${handle}`);
          mediaLink.setAttribute("href", keepUrl);
        }

        product.selected = Object.assign({}, product.selected, { gallery_idx: nextIdx });

        navCol.querySelectorAll(".compare-products__dash").forEach((el) => {
          const i  = Number(el.getAttribute("data-gallery-idx"));
          const on = i === nextIdx;
          el.classList.toggle("active", on);
          el.setAttribute("aria-current", on ? "true" : "false");
        });
      });
      return;
    }

    const sw = e.target.closest("[data-swatch]");
    if (sw && this.contains(sw)) { this._onSwatchClick(sw); return; }

    const chip = e.target.closest(".compare-products__tray-active-item");
    if (chip && this.contains(chip)) {
      e.preventDefault();
      const handle = chip.getAttribute("data-handle") || "";
      const title  = chip.getAttribute("data-title")  || chip.textContent.trim();
      if (handle) this._onCollectionChip(handle, title);
    }
  }

  _persistActiveSet(){
    const activeCol = readActiveCollection()?.handle;
    if (!activeCol) return;

    const handles = this._readHandles();
    const actives = handles.filter(h => !this._isDisabled(h)).slice(0, this.state.maxColumns);

    this._writeHandlesForCollection(activeCol, actives);

    const { sticky, refCol } = _stickyPdpInfo?.() || {};
    if (sticky && refCol && refCol === String(activeCol).toLowerCase()) {
      try {
        _writePdpHandlesForCollection(activeCol, actives);

        sessionStorage.setItem('compare:pdp:seeds', JSON.stringify(actives));
        sessionStorage.setItem('compare:pdp:refCol', activeCol);
        sessionStorage.setItem('compare:pdp:sticky', '1');

        const u = new URL(location.href);
        const cameFromPDP = (u.searchParams.get('from') || '').toLowerCase() === 'pdp';
        if (cameFromPDP) {
          if (actives.length) u.searchParams.set('seed', actives.join(','));
          else u.searchParams.delete('seed');
          history.replaceState(history.state, '', u.toString());
        }
      } catch {}
    }
  }


  _syncUrlWithActiveCollection({ push = true } = {}) {
    const active = readActiveCollection();
    if (active?.handle) {
      writeActiveCollectionToURL({ handle: active.handle }, { push });
    }
  }

  _canonicalizePickListToColor(picks = [], color = DEFAULT_COLOR_SLUG){
    const seen = new Set();
    const out  = [];

    (Array.isArray(picks) ? picks : []).forEach((h) => {
      if (!h) return;
      let target = String(h).toLowerCase();

      if (_isHandleColor(target, color)) {
        if (!seen.has(target)) { seen.add(target); out.push(target); }
        return;
      }

      const items = this._getItemsForHandle(target);
      if (Array.isArray(items) && items.length){
        const byCode   = items.find(it => String(it?.color_code || "").toLowerCase() === String(color).toLowerCase());
        const byHandle = items.find(it => _isHandleColor(it?.handle, color));
        const pick = byCode || byHandle;
        if (pick?.handle) target = String(pick.handle).toLowerCase();
        else return;
      } else {
        if (!_isHandleColor(target, color)) return;
      }

      if (!seen.has(target)) { seen.add(target); out.push(target); }
    });

    return out;
  }

  _readHandlesForCollection(colHandle) {
    if (!colHandle) return [];

    const col = String(colHandle).toLowerCase();
    const navFrom = (() => {
      try {
        const ss = (sessionStorage.getItem('compare:from') || '').toLowerCase();
        const ls = (localStorage.getItem('compare:last_source') || '').toLowerCase();
        return ss || ls;
      } catch { return ''; }
    })();
    const fromPLP = navFrom === 'plp';

    if (!fromPLP) {
      try {
        const { sticky, refCol } = _stickyPdpInfo?.() || {};
        if (sticky && refCol && refCol === col) {
          const pdp = _readPdpHandlesForCollection(col) || [];
          if (pdp.length) return _uniq(pdp.map(h => String(h||'').toLowerCase()).filter(Boolean));
        }
      } catch {}
    }

    try {
      const raw   = localStorage.getItem(handlesKeyForCollection(col));
      const arr   = raw ? JSON.parse(raw) : [];
      const picks = Array.isArray(arr) ? arr : [];

      const from = (() => {
        try {
          const ss = (sessionStorage.getItem('compare:from') || '').toLowerCase();
          const ls = (localStorage.getItem('compare:last_source') || '').toLowerCase();
          return ss || ls;
        } catch { return ''; }
      })();

      const allowColors = from === 'plp' || from === 'pdp';

      return allowColors
        ? _uniq(picks.map(h => String(h||"").toLowerCase()).filter(Boolean))
        : this._canonicalizePickListToColor(picks, DEFAULT_COLOR_SLUG);
    } catch {
      return [];
    }
  }

  _writeHandlesForCollection(colHandle, arr) {
    if (!colHandle) return;

    let next = _uniq(arr || []).map(h => String(h||"").toLowerCase());

    const from = (() => {
      try {
        const ss = (sessionStorage.getItem('compare:from') || '').toLowerCase();
        const ls = (localStorage.getItem('compare:last_source') || '').toLowerCase();
        return ss || ls;
      } catch { return ''; }
    })();
    const allowColors = from === 'plp' || from === 'pdp';

    if (!allowColors) {
      next = this._canonicalizePickListToColor(next, DEFAULT_COLOR_SLUG);
    }

    try {
      localStorage.setItem(handlesKeyForCollection(colHandle), JSON.stringify(next));
    } catch {}
  }

  _writeHandles(arr) {
    let next = _uniq(arr || []);

    if (this._mutatingWrite) return;
    this._mutatingWrite = true;

    try {
      const from = (() => {
        try {
          const ss = (sessionStorage.getItem('compare:from') || '').toLowerCase();
          const ls = (localStorage.getItem('compare:last_source') || '').toLowerCase();
          return ss || ls;
        } catch { return ''; }
      })();
      const allowColors = from === 'plp' || from === 'pdp';
      const wl = (this._colorWhitelist instanceof Set) ? this._colorWhitelist : new Set();
      if (wl.size) {
        const keep = [];
        const rest = [];
        const seen = new Set();
        for (const h of next) {
          if (!seen.has(h)) {
            (wl.has(h) ? keep : rest).push(h);
            seen.add(h);
          }
        }
        next = [...keep, ...rest];
      }

      try {
        const active = (typeof readActiveCollection === 'function' ? readActiveCollection() : null)?.handle;
        if (active && typeof this._shouldUseBlackOnly === 'function' && this._shouldUseBlackOnly(active)) {
          if (!allowColors) {
            if (typeof _filterHandlesByColor === 'function') {
              const blacks = _filterHandlesByColor(next, DEFAULT_COLOR_SLUG);
              if (Array.isArray(blacks) && blacks.length) next = _uniq(blacks);
            }
          }
        }
      } catch {}

      let prev;
      try { prev = JSON.parse(localStorage.getItem(COMPARE_WORKING_KEY) || '[]'); } catch { prev = []; }
      if (this._handlesEqual(prev, next)) return;

      try { localStorage.setItem(COMPARE_WORKING_KEY, JSON.stringify(next)); } catch {}

      if (!this._suppressCompareChange && !this._suppressEvents && !this._deferFirstPaint && !this._booting) {
        try { window.dispatchEvent(new CustomEvent("compare_change", { detail: { handles: next } })); } catch {}
      }
    } finally {
      this._mutatingWrite = false;
    }
  }

  async _commitOrdered(ordered, { chosen = null, silent = false } = {}) {
    const list = _uniq(ordered || []);
    if (chosen && chosen.length) this._colorWhitelist = new Set(chosen);

    const prevSuppress = this._suppressCompareChange;
    this._suppressCompareChange = !!silent;
    this._writeHandles(list);
    this._suppressCompareChange = prevSuppress;

    await this._ensureData();
    await this._ensureThumbsFor(list);

    this._render();
  }

  async _resetOtherCollectionsToBlackDefaults(currentHandle) {
    const list = Array.isArray(DEFAULT_COMPARE_COLLECTIONS) ? DEFAULT_COMPARE_COLLECTIONS : [];
    for (const c of list) {
      const h = (c?.handle || "").toLowerCase();
      if (!h || h === String(currentHandle).toLowerCase()) continue;

      const existing = (() => {
        try { 
          const raw = localStorage.getItem(`compare:handles:${h}`);
          const arr = raw ? JSON.parse(raw) : [];
          return Array.isArray(arr) ? arr.filter(Boolean) : [];
        } catch { return []; }
      })();
      if (existing.length) {
        if (!_readCollectionMode(h)) _writeCollectionMode(h, "black");
        continue;
      }

      _writeCollectionMode(h, "black");

      try {
        const defaults = await this._fetchCollectionDefaultHandles(h);
        const full = this._normalizeFull(defaults || []);
        const chosen = full.length ? [full[0]] : [];
        this._writeHandlesForCollection(h, chosen);
      } catch (e) {
        console.warn("[compare] reset defaults failed for", h, e);
      }
    }
  }


  async _onCollectionChip(handle, title = "") {
    try {
      handle = String(handle || "").toLowerCase();
      if (!handle) return;

      try {
        const prev = (readActiveCollection()?.handle || "").toLowerCase();
        if (prev) this._persistActiveSet();
      } catch {}

      try {
        localStorage.setItem(
          typeof ACTIVE_COLLECTION_KEY !== "undefined" ? ACTIVE_COLLECTION_KEY : "compare:active_collection",
          JSON.stringify({ handle, title: title || handle.replace(/-/g, " ").replace(/\b\w/g, s => s.toUpperCase()) })
        );
        const u = new URL(location.href);
        u.searchParams.set("refCol", handle);
        history.pushState({ refCol: handle }, "", u.toString());
      } catch {}

      this.classList.add("compare-products--loading");

      await this._fetchCollectionCatalog(handle);

      let full = this._normalizeFull(await this._fetchAllProductHandlesInCollection(handle));
      if (typeof this._isExcluded === "function") full = full.filter(h => !this._isExcluded(h));

      if (this._shouldUseBlackOnly(handle)) {
        const blacks = _filterHandlesByColor(full, DEFAULT_COLOR_SLUG);
        if (blacks.length) full = blacks;
      }

      const saved = (this._readHandlesForCollection(handle) || []).map(h => String(h||"").toLowerCase());

      const chosen = saved.length
        ? saved.filter(h => full.includes(h)).slice(0, this.state.maxColumns)
        : (full.length ? [full[0]] : []);


      let rest = full.filter(h => !chosen.includes(h));
      rest = _filterHandlesByColor(rest, DEFAULT_COLOR_SLUG);

      const ordered = Array.from(new Set([...chosen, ...rest]));

      this._writeHandlesForCollection(handle, chosen);
      this.state._disabledHandles = new Set(rest);
      await this._commitOrdered(ordered, { chosen, silent: false });

      this.classList.remove("compare-products--loading");

      try {
        const anyColor = chosen.some(h => !_isHandleColor(h, DEFAULT_COLOR_SLUG));
        if (anyColor) {
          sessionStorage.setItem('compare:from', 'plp');
          localStorage.setItem('compare:last_source', 'plp');
        }
      } catch {}

      const h = handle;
      this.querySelectorAll('.compare-products__tray-active-item').forEach(el=>{
        const on = ((el.dataset.handle || '').toLowerCase() === h);
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true':'false');
        el.tabIndex = on ? 0 : -1;
      });


    } catch (e) {
      console.warn('[compare] _onCollectionChip failed for', handle, e);
    }
  }


  _clearAllSavedPicks() {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(k => {
        if (k.startsWith("compare:handles:")) localStorage.removeItem(k);
      });
      localStorage.removeItem("compare:handles:working");
      localStorage.removeItem("compare:last_source");
      console.log("[compare] Cleared all saved picks from LS");
    } catch (err) {
      console.warn("[compare] Failed to clear saved picks", err);
    }
  }

  _isGid(v) { return typeof v === "string" && v.startsWith("gid://"); }

  _rehydrateDisabledFromLS() {
    const activeCol = readActiveCollection()?.handle;
    if (!activeCol) return;

    const allHandles = this._readHandles();
    if (!allHandles.length) return;

    const savedActives = this._readHandlesForCollection(activeCol) || [];

    let activeSet;
    if (savedActives.length) {
      activeSet = new Set(savedActives);
    } else {
      activeSet = new Set([allHandles[0]].filter(Boolean));
    }

    const rest = allHandles.filter(h => !activeSet.has(h));
    this.state._disabledHandles = new Set(rest);
  }

  async _resolveMetaobjects(ids = []) {
    const need = [...new Set(ids)].filter(id => id && !this._moCache[id]);
    if (!need.length) return;

    const nodes = await window.__VPV?.storefront?.q?.(`
      query($ids:[ID!]!){
        nodes(ids:$ids){
          __typename
          ... on Metaobject {
            id
            type
            fields{
              key
              value
              reference{
                __typename
                ... on MediaImage { image { url } }
                ... on GenericFile { url } }
              references(first: 10){
                edges{ node{
                  __typename
                  ... on MediaImage { image { url } }
                  ... on GenericFile { url } } } }
            }
          }
        }
      }
    `, { ids: need });

    const urlFromField = (f) => {
      if (!f) return "";
      const r = f.reference;
      if (r?.__typename === "MediaImage" && r.image?.url) return r.image.url;
      if (r?.__typename === "GenericFile" && r.url)       return r.url;
      const e = f.references?.edges?.find(ed => ed?.node?.image?.url || ed?.node?.url);
      return e?.node?.image?.url || e?.node?.url || "";
    };

    (nodes?.nodes || []).forEach(mo => {
      if (mo?.__typename !== "Metaobject") return;
      const fields = mo.fields || [];
      const labelF = fields.find(f => /^(label|name|title)(\b|_|-|\.)?/i.test(f.key));
      const iconF  = fields.find(f => /^(icon|image|logo)(\b|_|-|\.)?/i.test(f.key));

      this._moCache[mo.id] = {
        id: mo.id,
        type: String(mo.type || "").toLowerCase(),
        label: String(labelF?.value || ""),
        icon: urlFromField(iconF) || ""
      };
    });
  }

  _hasAnyFeatureData(p) {
    return Array.isArray(this.state.features) && this.state.features.some(f => this._hasDataForFeature(p, f));
  }

  _columnNeedsHydration(el, handle) {
    const p = this.state.productsByHandle[handle];
    if (!p) return false; // not hydrated yet
    const stack = el.querySelector('.compare-products__features-stack');

    if (stack?.classList.contains('is-empty') && this._hasAnyFeatureData(p)) return true;
    return false;
  }

  _enableTrayItem(h, { swapIfFull = true, promoteInOrder = true } = {}) {
    if (!h || this._isExcluded(h)) return;
    if (!h) return;

    // current tray order from LS
    let handles = this._readHandles();
    if (!handles.includes(h)) handles = [...handles, h]; // just in case

    const wasDisabled = this._isDisabled(h);

    // If grid is full and this item wasn't active, soft-disable the rightmost active to make room
    const enabledNow = handles.filter(x => !this._isDisabled(x));
    const gridFull   = enabledNow.length >= this.state.maxColumns;

    if (gridFull && (wasDisabled || !enabledNow.includes(h))) {
      if (!swapIfFull) return;
      const victim = enabledNow[enabledNow.length - 1];
      if (victim && victim !== h) {
        this.state._disabledHandles.add(victim);
        this._setTrayItemEnabled(victim, false); // update chip UI immediately
      }
    }

    // Enable clicked handle
    this.state._disabledHandles.delete(h);
    this._setTrayItemEnabled(h, true); // update chip UI immediately

    // Rebuild order so that `h` ends up inside the active block
    // (right after current actives) to guarantee it shows in the columns
    const withoutH   = handles.filter(x => x !== h);
    const actives    = withoutH.filter(x => !this._isDisabled(x));
    const disabled   = withoutH.filter(x => this._isDisabled(x));

    let newActives = promoteInOrder ? [h, ...actives] : [...actives, h];

    // clamp to max columns (if we swapped a victim above this will already fit)
    newActives = newActives.slice(0, this.state.maxColumns);

    const rest = withoutH.filter(x => !newActives.includes(x));
    const finalOrder = [...newActives, ...rest];

    // Persist & sync
    this._writeHandles(finalOrder);
    this._persistActiveSet();
    this._syncFromStorage();
    // Fetch any missing data then refresh only the columns
    this._ensureData().then(() => this._renderColumnsOnly());
  }

  _onRemoveChip(h){
    if (!h) return;
    const handles = this._readHandles();
    if (!handles.includes(h)) return;

    this.state._disabledHandles.add(h);
    this._setTrayItemEnabled(h, false);
    this._syncFromStorage();
    this._persistActiveSet();
    this._renderColumnsOnly();

  }

  _isDisabled(handle){
    return this.state._disabledHandles.has(handle);
  }

  // Get resolved metaobjects for a product's feature key (using ids or gid strings)
  _getMetaobjectsForProduct(p, key){
    if (!p || !key) return [];
    const out = [];

    const pushId = (id) => {
      const obj = id && this._moCache[id];
      if (obj) out.push(obj);
    };

    const ids = (p.metafields_ids && p.metafields_ids[key]) || [];
    ids.forEach(pushId);

    const rawVals = this._valuesFor(p, key);
    rawVals.forEach(v => { if (this._isGid(v)) pushId(v); });

    const seen = new Set();
    return out.filter(o => (o?.id && !seen.has(o.id) ? (seen.add(o.id), true) : false));
  }

  _collectionKeyForFeature(f){
    // fully dynamic: prefer explicit collection_key, otherwise the feature's value
    return String((f && (f.collection_key || f.value)) || "").trim();
  }

  _collectionKeysToFetch(){
    const keys = (this.state.features || [])
      .map(f => this._collectionKeyForFeature(f))
      .filter(Boolean);
    return Array.from(new Set(keys));
  }

  // Data presence checks for a feature (incl. warmth special-case)
  _hasDataForFeature(p, f){
    const key = this._collectionKeyForFeature(f);
    if (!key) return false;

    // Warmth: only show if we have a valid max and a value
    theWarmth: {
      const isWarmth = String(f?.title || "").toLowerCase() === "warmth";
      if (!isWarmth) break theWarmth;
      const raw = this._valuesFor(p, f.value);
      const s   = raw[0];
      if (s == null || String(s).trim() === "") return false;

      const [ , maxFromPair ] = this._parseMeterPair(s);
      const addArr            = this._valuesFor(p, f.additional_value);
      const explicitMax       = parseInt(addArr[0], 10);
      const fallbackMax       = Number.isFinite(Number(f?.max)) ? Number(f.max) : 8;
      const max               = maxFromPair || (Number.isFinite(explicitMax) ? explicitMax : fallbackMax);
      return Number.isFinite(max) && max > 0;
    }

    // If this feature has a collection catalog, only count it as "has data"
    // when the product actually has at least one *active* item.
    const catalogItems = this._getCollectionItems(key) || [];
    if (catalogItems.length) {
      const keysToCheck = Array.from(new Set([
        ...this._synonymKeys(key),
        ...this._synonymKeys(f.value),
        f.additional_value
      ].filter(Boolean)));

      const hasAnyActive = catalogItems.some(it =>
        this._isAttrActiveForProductAny(p, keysToCheck, it)
      );
      if (hasAnyActive) return true;
    }

    // Metaobjects directly attached to the product?
    const hasProductMetaObjs = this._getMetaobjectsForProduct(p, key).length > 0;

    // Plain-text metafields on the product?
    const hasText       = this._valuesFor(p, key).filter(v => !this._isGid(v)).length > 0;
    const hasAdditional = this._valuesFor(p, f.additional_value).filter(v => !this._isGid(v)).length > 0;

    // Only show if at least one of the above is present
    return hasProductMetaObjs || hasText || hasAdditional;
  }

  _getCollectionItems(key){
    return (this.state.collectionCatalog && this.state.collectionCatalog[key]) || [];
  }

  _isAttrActiveForProduct(p, productKey, item){
    if (!p) return false;

    const ids = (p.metafields_ids && p.metafields_ids[productKey]) || [];
    if (item?.id && ids.includes(item.id)) return true;

    const labels = this._valuesFor(p, productKey).map(s => s.toLowerCase());
    if (item?.label && labels.includes(String(item.label).toLowerCase())) return true;

    return false;
  }

  _readHandles() {
    try {
      const raw = localStorage.getItem(COMPARE_WORKING_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      const list = Array.isArray(parsed) ? parsed : Array.isArray(parsed?.handles) ? parsed.handles : [];
      return this._filterOutExcluded(list);  // <-- filtra aquí
    } catch { return []; }
  }

  async _removeHandle(handle) {
    if (!handle) return;
    const next = this._readHandles().filter(h => h !== handle);
    this._writeHandles(next);
    this.state._disabledHandles.delete(handle);
    this._syncFromStorage();

    await this._ensureData();
    await this._ensureThumbsFor(next);
    this._render();
  }

  // ---------- seed ----------
  _seedEl() {
    return this.querySelector(':scope > script[type="application/json"][js-data]');
  }

  _whenSeedReady() {
    const el = this._seedEl();
    if (el) return Promise.resolve(el);
    return new Promise((resolve) => {
      const mo = new MutationObserver(() => {
        const s = this._seedEl();
        if (s) { mo.disconnect(); resolve(s); }
      });
      mo.observe(this, { childList: true, subtree: false });
    });
  }

  _parseSeed() {
    try {
      const script = this._seedEl();
      if (!script) return;
      const json = JSON.parse(script.textContent || "{}");

      this.state.sectionTitle = String(json.title || this.state.sectionTitle || "");

      const products = Array.isArray(json.products) ? json.products : [];
      const features = Array.isArray(json.features) ? json.features : [];

      const titlesMap = readTitles();
      const thumbsMap = readThumbs();

      products.forEach((p) => {
        const handle = this._extractHandle(p.url || "");
        if (!handle) return;

        if (p.title) titlesMap[handle] = String(p.title);
        if (p.image) thumbsMap[handle] = String(p.image);

        this.state.seedByHandle[handle] = {
          handle,
          id: p.id,
          title: p.title,
          url: p.url,
          image: p.image,
          price: p.price,
          vendor: p.vendor,
          metafields: {}
        };
        this.state.seedOrder.push(handle);
      });

      // Optional: collection defaults provided by JSON seed
      const defs = Array.isArray(json.collectionDefaults) ? json.collectionDefaults : [];
      const byHandle = {};
      defs.forEach(g => {
        const colHandle = String(g?.handle || "").trim();
        const items = Array.isArray(g?.products) ? g.products : [];
        const handles = items
          .map(p => (typeof p === "string" ? p : p?.url || ""))
          .map(u => this._extractHandle(u))
          .filter(Boolean);
        if (colHandle && handles.length) byHandle[colHandle] = handles;
      });
      this.state.collectionDefaultsByHandle = byHandle;

      writeTitles(titlesMap);

      // Collections list (fallback to DEFAULT_COMPARE_COLLECTIONS)
      const co = Array.isArray(json.collections) ? json.collections : [];
      this.state.collections = co.map(c => ({
        title: String(c?.title || ""),
        handle: String(c?.handle || ""),
        url: c?.url ? String(c.url) : (c?.handle ? `/collections/${c.handle}` : "#")
      })).filter(c => c.title);

      if (!this.state.collections.length) {
        this.state.collections = DEFAULT_COMPARE_COLLECTIONS.map(c => ({
          ...c,
          url: `/collections/${c.handle}`
        }));
      }

      this.state.features = features;
    } catch (e) {
      log("[compare] seed parse error:", e);
    }
  }

  _extractHandle(url) {
    try {
      const u = new URL(url, location.origin);
      const parts = u.pathname.split("/").filter(Boolean);
      const i = parts.indexOf("products");
      return i >= 0 && parts[i + 1] ? parts[i + 1] : "";
    } catch { return ""; }
  }

  // Return an array of collection handles whose handle contains the substring (case-insensitive)
  async _fetchCollectionHandlesBySubstring(substr = "base-layer") {
    const target = String(substr || "").toLowerCase();
    // pull first 250 collections (adjust if you need more)
    const data = await window.__VPV?.storefront?.q?.(`
      query {
        collections(first: 250) {
          edges { node { handle title } }
        }
      }
    `);

    const edges = data?.collections?.edges || [];
    return edges
      .map(e => e?.node?.handle)
      .filter(h => typeof h === "string" && h.toLowerCase().includes(target));
  }

  // Paginate through ALL product handles in a single collection
  async _fetchAllProductHandlesInCollection(collectionHandle) {
    const out = [];
    let after = null;

    while (true) {
      const data = await window.__VPV?.storefront?.q?.(
        `query($handle:String!,$after:String){
          collection(handle:$handle){
            products(first: 100, after:$after, sortKey: MANUAL, reverse: false){
              pageInfo { hasNextPage endCursor }
              edges { node { handle } }
            }
          }
        }`,
        { handle: collectionHandle, after }
      );

      const page = data?.collection?.products;
      const edges = page?.edges || [];
      edges.forEach(e => { const h = e?.node?.handle; if (h) out.push(h); });

      if (page?.pageInfo?.hasNextPage) {
        after = page.pageInfo.endCursor;
      } else {
        break;
      }
    }
    return this._filterOutExcluded(out);
  }

  // Choose your mobile breakpoint (<= 768px)
  _isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  }

  _applyResponsiveColumns() {
    const want = this._isMobile() ? 2 : 3;
    if (this.state.maxColumns !== want) {
      this.state.maxColumns = want;
      this._syncFromStorage();  
      this._rehydrateDisabledFromLS();
      this._renderColumnsOnly();  
    }
  }

  // ---------- sync ----------
  _syncFromStorage(){
    const handles = this._readHandles();
    this._prevHandles = Array.isArray(handles) ? handles.slice() : [];
    const enabled = handles.filter(h => !this._isDisabled(h));
    this.state.columns = enabled.slice(0, this.state.maxColumns);
  }

  _enableNewlyAddedHandles(latest) {
    if (!this.state.onCollectionPage) return;

    const before = new Set(this._prevHandles || []);
    const after  = Array.isArray(latest) ? latest : [];

    // Any handle present "after" but not "before" is newly added
    const newlyAdded = after.filter(h => !before.has(h));

    // Also treat re-ordered items that were previously soft-disabled as "re-enabled"
    newlyAdded.forEach(h => this.state._disabledHandles.delete(h));

    // If there were no truly new items, but user re-toggled an existing disabled item,
    // we can heuristically enable the last one in the list (acts like "most recent"):
    if (!newlyAdded.length && after.length) {
      const last = after[after.length - 1];
      if (this.state._disabledHandles.has(last)) {
        this.state._disabledHandles.delete(last);
      }
    }
  }

  _patchTrayThumbs(handles){
    const thumbs = readThumbs();
    (handles || []).forEach((h) => {
      const key  = String(h || "").toLowerCase();
      const url  = thumbs[key] && unsizeImage(thumbs[key]);
      const img  = this.querySelector(`.compare-products__tray-item[data-handle="${h}"] img`);
      const wrap = this.querySelector(`.compare-products__tray-item[data-handle="${h}"] .compare-products__tray-image`);
      if (img && url) {
        if (img.getAttribute('src') !== url) img.src = url;
        if (wrap) {
          wrap.classList.remove('is-skeleton');
          wrap.removeAttribute('aria-busy');
        }
      }
    });
  }

  _patchColumnPrimaryImage(handle){
    const col = this.querySelector(`.compare-products__col[data-handle="${handle}"]`);
    if (!col) return;
    const img = col.querySelector('.compare-products__media img');
    const p   = this.state.productsByHandle[handle] || this.state.seedByHandle[handle];
    const url = (p?.selected?.image || p?.image || readThumbs()[handle] || "").trim();
    if (img && url) img.src = url;
  }

  async _ensureTrayCompareCopy() {
    const handles = (this._readHandles() || []).filter(Boolean);
    if (!handles.length || !window.__VPV?.storefront?.q) return;

    const missing = handles.filter(h => {
      const p = this.state.productsByHandle[h] || this.state.seedByHandle[h] || null;
      const title = (p?.compare_title || "").trim();
      const desc  = (p?.compare_description || "").trim();
      return !(title || desc);
    });

    if (!missing.length) {
      handles.forEach(h => this._patchTrayTooltip(h));
      return;
    }

    const sels = missing.map((h, i) => `
      h${i}: product(handle: "${h}") {
        compareTitle:       metafield(namespace:"custom", key:"compare_title")       { value }
        compareDescription: metafield(namespace:"custom", key:"compare_description") { value }
        handle
        title
        onlineStoreUrl
        featuredImage { url(transform:{ maxWidth: 800 }) }
      }
    `).join('\n');

    try {
      const data = await window.__VPV?.storefront?.q?.(`query TrayCopy { ${sels} }`);
      missing.forEach((h, i) => {
        const node = data?.[`h${i}`];
        if (!node) return;

        const existing = this.state.productsByHandle[h] || this.state.seedByHandle[h] || {};
        const image = existing.image || node?.featuredImage?.url || "";

        const compare_title       = this._richToText(node?.compareTitle?.value);
        const compare_description = this._richToText(node?.compareDescription?.value);

        this.state.productsByHandle[h] = {
          handle: h,
          title: existing.title || node?.title || h,
          url: existing.url || node?.onlineStoreUrl || `/products/${h}`,
          image: existing.image || image,
          compare_title,
          compare_description,
          metafields: existing.metafields || {},
          metafields_ids: existing.metafields_ids || {}
        };

        this._patchTrayTooltip(h);
      });
    } catch (e) {
      try { console.warn("[compare] ensure tray copy failed", e); } catch {}
    }
  }

  _patchTrayTooltip(handle){
    const el = this.querySelector(`.compare-products__tray-item[data-handle="${handle}"] .compare-products__tray-image`);
    if (!el) return;

    const p = this.state.productsByHandle[handle] || this.state.seedByHandle[handle] || null;
    if (!p) return;

    const { title, description } = this._getCompareCopy(p);
    const hasCopy = (title && title.trim()) || (description && description.trim());
    if (!hasCopy) return;

    let hover = el.querySelector(".compare-products__tray-hover");
    const html = `
      ${title ? `<div class="compare-products__copy-title">${this._t(title)}</div>` : ""}
    `.trim();

    if (hover) {
      hover.innerHTML = html;
      hover.setAttribute("aria-hidden", "true");
    } else {
      el.insertAdjacentHTML("beforeend", `
        <div class="compare-products__tray-hover" role="tooltip" aria-hidden="true">
          ${html}
        </div>
      `);
    }
  }

  _onCompareChange() {

    if (this._handlingCompareChange || this._booting || this._suppressEvents || this._deferFirstPaint) return;
    this._handlingCompareChange = true;
    try {
      const latest = this._readHandles();
      this._enableNewlyAddedHandles(latest);
      this._syncFromStorage();
      this._ensureData().then(async () => {
        const ordered = this._readHandles();
        await this._ensureThumbsFor(ordered);
        this._render();

        try {
          const activeHandle = (readActiveCollection()?.handle || "").toLowerCase();
          if (activeHandle) {
            const chosen = ordered.slice(0, this.state.maxColumns);
            if (chosen.length) this._writeHandlesForCollection(activeHandle, chosen);
          }
        } catch {}
      });

    } finally {
      this._handlingCompareChange = false;
    }
  }

  _onStorage() {
    if (this._handlingCompareChange || this._booting || this._suppressEvents || this._deferFirstPaint) return;
    this._handlingCompareChange = true;
    try {
      const latest = this._readHandles();
      this._enableNewlyAddedHandles(latest);
      this._syncFromStorage();
      this._ensureData().then(() => this._render());
    } finally {
      this._handlingCompareChange = false;
    }
  }

  // ---------- pricing helpers ----------
  _money(n) {
    try {
      const curr = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
      const val  = Math.ceil(Number(n || 0));
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: curr,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(val);
    } catch {
      return `$${Math.ceil(Number(n || 0))}`;
    }
  }
  
  _computeDisplayPrice({priceMin, compareMin, discountPct}) {
    const p = Number(priceMin || 0)
        , cp = Number(compareMin || 0)
        , d = Math.max(0, Math.min(100, Number(discountPct || 0)))
        , discounted = d > 0 ? p * (1 - d / 100) : p;
    let price = p, compare = 0;
    const byCompareAt = cp > p && p > 0;
    const theByMeta = discounted < p;
    if (theByMeta && byCompareAt) { price = Math.min(discounted, p); compare = Math.max(cp, p); }
    else if (theByMeta) { price = discounted; compare = p; }
    else if (byCompareAt) { price = p; compare = cp; }
    price = Math.ceil(price); compare = Math.ceil(compare);
    return {
      price_num: price,
      compare_at_num: compare,
      on_sale: compare > price,
      discount_pct: compare > price ? Math.round((1 - price / compare) * 100) : 0
    };
  }

  // ---------- rich text normalizer ----------
  _richToText(v) {
    if (!v) return "";
    if (typeof v === "string" && v.trim() && v[0] !== "{" && v[0] !== "[") return v.trim();
    try {
      const obj = typeof v === "string" ? JSON.parse(v) : v;
      const walk = (n) => Array.isArray(n)
        ? n.map(walk).join("")
        : (n && typeof n === "object")
          ? (typeof n.text === "string" ? n.text : "") + (n.children ? walk(n.children) : "")
          : "";
      if (obj && obj.children) return walk(obj.children).trim();
    } catch {}
    return String(v).trim();
  }

  // ---------- collection catalog (features/activity/etc) ----------
  async _fetchCollectionCatalog(collectionHandle){
    if (!collectionHandle) return;
    if (this._catalogRequestInFlight) return;
    this._catalogRequestInFlight = true;

    try {
      const keys = this._collectionKeysToFetch();
      if (!keys.length) {
        this.state.collectionCatalog = {};
        return;
      }

      const mfSel = keys.map((k,i) => `
        k${i}: metafield(namespace: "custom", key: "${k}") {
          reference { __typename ... on Metaobject { id } }
          references(first: 100) { edges { node { __typename ... on Metaobject { id } } } }
          value
          type
        }
      `).join('\n');

      const res = await window.__VPV?.storefront?.q?.(`
        query($handle:String!){
          collection(handle: $handle){
            id handle title
            ${mfSel}
          }
        }
      `, { handle: collectionHandle });

      const col = res?.collection;
      if (!col) { this.state.collectionCatalog = {}; return; }

      const idGroups = {};
      const isMoGid = s => typeof s === "string" && /^gid:\/\/shopify\/Metaobject\//i.test(s);

      keys.forEach((k, i) => {
        const mf  = col[`k${i}`];
        const ids = [];

        if (mf?.reference?.__typename === "Metaobject" && mf.reference.id) ids.push(mf.reference.id);
        (mf?.references?.edges || []).forEach(ed => {
          const n = ed?.node;
          if (n?.__typename === "Metaobject" && n.id) ids.push(n.id);
        });

        if (mf?.value) {
          try {
            const v = JSON.parse(mf.value);
            if (Array.isArray(v)) v.forEach(x => { if (isMoGid(x)) ids.push(x); });
            else if (isMoGid(v)) ids.push(v);
          } catch {
            String(mf.value)
              .split(/[\s,|]+/)
              .filter(isMoGid)
              .forEach(g => ids.push(g));
          }
        }

        if (ids.length) idGroups[k] = Array.from(new Set(ids));
      });

      const allIds = [...new Set(Object.values(idGroups).flat())];
      if (!allIds.length) { this.state.collectionCatalog = {}; return; }

      const nodes = await window.__VPV?.storefront?.q?.(`
        query($ids:[ID!]!){
          nodes(ids:$ids){
            __typename
            ... on Metaobject {
              id
              type
              fields {
                key
                value
                reference {
                  __typename
                  ... on MediaImage { image { url } }
                  ... on GenericFile { url } }
                references(first: 10){
                  edges { node {
                    __typename
                    ... on MediaImage { image { url } }
                    ... on GenericFile { url } } }
                }
              }
            }
          }
        }
      `, { ids: allIds });

      const byId = {};
      const urlFromField = (f) => {
        if (!f) return "";
        const r = f.reference;
        if (r?.__typename === "MediaImage" && r.image?.url) return r.image.url;
        if (r?.__typename === "GenericFile" && r.url)       return r.url;
        const e = f.references?.edges?.find(ed => ed?.node?.image?.url || ed?.node?.url);
        return e?.node?.image?.url || e?.node?.url || "";
      };

      (nodes?.nodes || []).forEach(mo => {
        if (mo?.__typename !== "Metaobject") return;
        const fields = mo.fields || [];
        const labelF = fields.find(f => /^(label|name|title)(\b|_|-|\.)?/i.test(f.key));
        const iconF  = fields.find(f => /^(icon|image|logo)(\b|_|-|\.)?/i.test(f.key));
        byId[mo.id] = {
          id: mo.id,
          type: (mo.type || "").toString().toLowerCase(),
          label: String(labelF?.value || ""),
          icon: urlFromField(iconF)
        };
      });

      const catalog = {};
      Object.entries(idGroups).forEach(([k, ids]) => {
        catalog[k] = ids.map(id => byId[id]).filter(Boolean);
      });

      this.state.collectionCatalog = catalog;
    } finally {
      this._catalogRequestInFlight = false;
    }
  }

  _synonymKeys(k){
    if (!k) return [];
    const set = new Set([k]);

    if (k.startsWith("compare_")) set.add(k.replace(/^compare_/, ""));
    else set.add(`compare_${k}`);

    const base = k.replace(/^compare_/, "");
    theBase:{
      const baseNoNum = base.replace(/_\d+$/, "");
      const sing = baseNoNum.replace(/s$/, "");
      [
        `compare_${baseNoNum}`, baseNoNum,
        `compare_${sing}`, `compare_${sing}s`, sing, `${sing}s`
      ].forEach(s => set.add(s));
    }

    return Array.from(new Set(set));
  }

  // ---------- data via GraphQL ----------
  async _ensureData(){
    const handles = this.state.columns.slice(0, this.state.maxColumns).filter(Boolean);
    if (!handles.length) return;

    const mfKeys = [];
    const pushKey = (k) => { if (k && !mfKeys.includes(k)) mfKeys.push(k); };
    this.state.features.forEach(f => {
      pushKey(this._collectionKeyForFeature(f));
      pushKey(f.value);
      pushKey(f.additional_value);
      pushKey(f.metafield_icon);
    });

    const mfSelections = mfKeys.map((key, i) => `
      mf${i}: metafield(namespace: "custom", key: "${key}") {
        type
        value
        reference { __typename ... on MediaImage { image { url } } ... on Metaobject { id } }
        references(first: 10) { edges { node { __typename ... on MediaImage { image { url } } ... on Metaobject { id } } } }
      }
    `).join('\n');

    const prodSelections = `
      id
      title
      handle
      vendor
      onlineStoreUrl
      featuredImage { url(transform: { maxWidth: 800 }) }
      images(first: 12) { edges { node { url(transform: { maxWidth: 1200 }) } } }
      priceRange { minVariantPrice { amount currencyCode } }
      compareAtPriceRange { minVariantPrice { amount currencyCode } }
      discountPercent: metafield(namespace:"custom", key:"discount_percentage_") { value }
      compareTitle:       metafield(namespace:"custom", key:"compare_title")       { type value }
      compareDescription: metafield(namespace:"custom", key:"compare_description") { type value }
      ${mfSelections}
      selectStitcher: metafield(namespace: "custom", key: "${SWATCH_MF_KEY}") {
        type
        value
        reference { __typename ... on Metaobject { id } }
        references(first: 10) { edges { node { __typename ... on Metaobject { id } } } }
      }
    `;

    const perHandle = handles.map((h, idx) => `h${idx}: product(handle: "${h}") { ${prodSelections} }`).join('\n');
    const query = `query CompareProducts { ${perHandle} }`;
    const allMoIds = new Set();

    const data = await window.__VPV?.storefront?.q?.(query);
    if (!data) return;

    const isMoGid = s => typeof s === "string" && /^gid:\/\/shopify\/Metaobject\//i.test(s);
    const gidsFromVal = (val) => {
      const out = [];
      if (val == null) return out;
      try {
        const j = JSON.parse(val);
        if (Array.isArray(j)) j.forEach(x => { if (isMoGid(x)) out.push(x); });
        else if (isMoGid(j)) out.push(j);
      } catch {
        String(val).split(/[\s,|]+/).forEach(t => { if (isMoGid(t)) out.push(t); });
      }
      return out;
    };

    handles.forEach((h, idx) => {
      const node = data[`h${idx}`];
      if (!node) return;

      const metafields = {};
      const metafieldsIds = {};

      mfKeys.forEach((k, i) => {
        const mf = node[`mf${i}`];
        if (!mf) return;

        const list = Array.isArray(mf?.references?.edges)
          ? mf.references.edges.map(e => e?.node?.image?.url).filter(Boolean)
          : [];
        const single = mf?.reference?.image?.url || null;
        const val = list.length ? list : (single ?? mf.value ?? null);
        if (val != null) metafields[k] = val;

        const ids = [];
        if (mf?.reference?.__typename === "Metaobject" && mf.reference.id) ids.push(mf.reference.id);
        (mf?.references?.edges || []).forEach(ed => {
          const n = ed?.node;
          if (n?.__typename === "Metaobject" && n.id) ids.push(n.id);
        });

        const fromValue = gidsFromVal(mf.value);
        fromValue.forEach(g => ids.push(g));

        if (ids.length) {
          const uniq = Array.from(new Set(ids));
          metafieldsIds[k] = uniq;
          uniq.forEach(id => allMoIds.add(id));
        }
      });

      const image = node?.featuredImage?.url || this.state.seedByHandle[h]?.image || '//cdn.shopify.com/s/images/admin/no-image-large-1.png';

      const priceMin    = Number(node?.priceRange?.minVariantPrice?.amount || 0);
      const compareMin  = Number(node?.compareAtPriceRange?.minVariantPrice?.amount || 0);
      const discountPct = Number(node?.discountPercent?.value || 0);
      const gallery =
        Array.isArray(node?.images?.edges)
          ? node.images.edges.map(e => e?.node?.url).filter(Boolean)
          : [];
      const pricing = this._computeDisplayPrice({ priceMin, compareMin, discountPct });

      this.state.productsByHandle[h] = {
        handle: node.handle || h,
        id: node.id,
        title: node.title,
        url: node.onlineStoreUrl || `/products/${h}`,
        compare_title:       this._richToText(node?.compareTitle?.value),
        compare_description: this._richToText(node?.compareDescription?.value),
        image,
        gallery,
        vendor: node.vendor || '',
        options: {},
        metafields,
        metafields_ids: metafieldsIds,
        price: pricing.price_num,
        compare_at: pricing.compare_at_num,
        on_sale: pricing.on_sale,
        discount_pct: pricing.discount_pct,
      };

      if (!this.state.seedByHandle[h]) {
        this.state.seedByHandle[h] = { handle:h, title: node.title, metafields_ids: metafieldsIds, url: node.onlineStoreUrl, image, metafields:{} };
      }
    });

    await this._resolveMetaobjects([...allMoIds]);

    // Stitcher family swatches
    const moIdByHandle = {};
    handles.forEach((h, idx) => {
      const node = data[`h${idx}`];
      if (!node) return;
      const st = node.selectStitcher;
      let moId = st?.reference?.id || (typeof st?.value === "string" ? st.value : null);
      if (!moId && Array.isArray(st?.references?.edges)) {
        const first = st.references.edges.find(e => e?.node?.__typename === "Metaobject");
        if (first) moId = first.node.id;
      }
      if (moId) moIdByHandle[h] = moId;
    });

    const nodesQuery = `
      query ($ids: [ID!]!) {
        nodes(ids: $ids) {
          __typename
          ... on Metaobject {
            id
            type
            fields {
              key type value
              references(first: 50) {
                edges { node {
                  __typename
                  ... on Product {
                    id handle title onlineStoreUrl
                    featuredImage { url(transform: { maxWidth: 800 }) }
                    images(first: 2) { edges { node { url(transform: { maxWidth: 800 }) } } }
                    priceRange { minVariantPrice { amount currencyCode } }
                    compareAtPriceRange { minVariantPrice { amount currencyCode } }
                    discountPercent: metafield(namespace:"custom", key:"discount_percentage_") { value }
                    colorCode: metafield(namespace:"custom", key:"color_code"){ value }
                    compareTitle:       metafield(namespace:"custom", key:"compare_title")       { value }
                    compareDescription: metafield(namespace:"custom", key:"compare_description") { value }
                  }
                } }
              }
            }
          }
        }
      }
    `;
    const metaIds = Object.values(moIdByHandle);
    if (metaIds.length) {
      const moRes = await window.__VPV?.storefront?.q?.(nodesQuery, { ids: metaIds });
      const moNodes = moRes?.nodes || [];

      for (const mo of moNodes) {
        if (mo?.__typename !== "Metaobject") continue;

        const ownerHandle = Object.keys(moIdByHandle).find(h => moIdByHandle[h] === mo.id);
        if (!ownerHandle) continue;

        const fields = Array.isArray(mo.fields) ? mo.fields : [];
        const prodField = fields.find(f => {
          const key = String(f?.key || "");
          const looksLikeSelectAll = /(^|[._-])select[_-]?all$/i.test(key);
          const typeHasProducts    = /product_reference/i.test(String(f?.type || ""));
          const refsHaveProducts   = (f?.references?.edges || []).some(e => e?.node?.__typename === "Product");
          return looksLikeSelectAll || typeHasProducts || refsHaveProducts;
        });

        let prodNodes =
          (prodField?.references?.edges || [])
            .map(e => e?.node)
            .filter(n => n?.__typename === "Product");

        if ((!prodNodes || !prodNodes.length) && prodField?.value) {
          try {
            const ids = JSON.parse(prodField.value);
            if (Array.isArray(ids) && ids.length) {
              const fetched = await window.__VPV?.storefront?.q?.(
                `query($ids:[ID!]!){
                  nodes(ids:$ids){
                    __typename
                    ... on Product {
                      id handle title onlineStoreUrl
                      featuredImage { url(transform: { maxWidth: 800 }) }
                      images(first: 2) { edges { node { url(transform: { maxWidth: 800 }) } } }
                      priceRange { minVariantPrice { amount currencyCode } }
                      compareAtPriceRange { minVariantPrice { amount currencyCode } }
                      discountPercent: metafield(namespace:"custom", key:"discount_percentage_") { value }
                      colorCode: metafield(namespace:"custom", key:"color_code"){ value }
                      compareTitle:       metafield(namespace:"custom", key:"compare_title")       { value }
                      compareDescription: metafield(namespace:"custom", key:"compare_description") { value }
                    }
                  }
                }`, { ids }
              );
              prodNodes = (fetched?.nodes || []).filter(n => n?.__typename === "Product");
            }
          } catch (e) { log("[compare] could not parse select_all.value", e, prodField?.value); }
        }

        const items = (prodNodes || []).map(p => {
          const imgs    = Array.isArray(p?.images?.edges) ? p.images.edges.map(ed => ed?.node?.url).filter(Boolean) : [];
          const primary = imgs[0] || p.featuredImage?.url || "";
          const hover   = imgs[1] || "";

          const priceMin    = Number(p?.priceRange?.minVariantPrice?.amount || 0);
          const compareMin  = Number(p?.compareAtPriceRange?.minVariantPrice?.amount || 0);
          const discountPct = Number(p?.discountPercent?.value || 0);
          const pricing     = this._computeDisplayPrice({ priceMin, compareMin, discountPct });

          return {
            id: p.id,
            handle: p.handle,
            title: p.title,
            url: p.onlineStoreUrl || `/products/${p.handle}`,
            compare_title:       this._richToText(p?.compareTitle?.value),
            compare_description: this._richToText(p?.compareDescription?.value),
            image: primary,
            hover_image: hover,
            color_code: p.colorCode?.value || null,
            price_num: pricing.price_num,
            compare_at_num: pricing.compare_at_num,
            on_sale: pricing.on_sale,
            discount_pct: pricing.discount_pct
          };
        });

        const target = this.state.productsByHandle[ownerHandle];
        if (target) {
          target.metafields = { ...(target.metafields || {}), [SWATCH_MF_KEY]: { items } };
        }
        const seed = this.state.seedByHandle[ownerHandle];
        if (seed) {
          seed.metafields = { ...(seed.metafields || {}), [SWATCH_MF_KEY]: { items } };
        }
      }
    }

    this._propagateSwatchesAcrossFamily();
    this._renderColumnsOnly();  
    this._updateThumbCacheFromHydrated(handles);

  }

  // near other utils
  _preloadedImgs = new Set();
  _preloadImages(urls = []){
    urls.forEach(u => {
      if (!u || this._preloadedImgs.has(u)) return;
      const img = new Image();
      img.decoding = "async";
      img.loading = "eager";
      img.src = u;
      this._preloadedImgs.add(u);
    });
  }

  _shouldUseBlackOnly(collectionHandle){
    const mode = _readCollectionMode(collectionHandle);
    if (mode) return mode !== "full";
    return true;
  }

  async _ensureGalleryForHandle(handle) {
    if (!handle) return [];
    const cached = this.state.productsByHandle[handle]?.gallery;
    if (Array.isArray(cached) && cached.length) return cached;

    const data = await window.__VPV?.storefront?.q?.(`
      query($h:String!){
        product(handle:$h){
          images(first: 12){ edges{ node{ url(transform:{ maxWidth: 1200 }) } } }
          featuredImage { url(transform:{ maxWidth: 1200 }) }
        }
      }
    `, { h: handle });

    const edges = data?.product?.images?.edges || [];
    const gallery = edges.map(e => e?.node?.url).filter(Boolean);
    const fallback = data?.product?.featuredImage?.url || "";

    if (!this.state.productsByHandle[handle]) {
      this.state.productsByHandle[handle] = { handle, gallery: gallery.length ? gallery : (fallback ? [fallback] : []) };
    } else {
      this.state.productsByHandle[handle].gallery = gallery.length ? gallery : (fallback ? [fallback] : []);
    }
    this._preloadImages((this.state.productsByHandle[handle].gallery || []).slice(0,4));
    return this.state.productsByHandle[handle].gallery || [];
  }

  _getGalleryForHandle(handle) {
    const g = this.state.productsByHandle[handle]?.gallery;
    return Array.isArray(g) ? g : [];
  }


  async _applyCollectionDefaults(collectionHandle, { softDisableAll = false } = {}) {
    if (!collectionHandle) return;

    let handles = this.state.collectionDefaultsByHandle?.[collectionHandle];
    if (!Array.isArray(handles) || !handles.length) {
      handles = await this._fetchAllProductHandlesInCollection(collectionHandle);
    }
    handles = _uniq(handles);

    if (this._shouldUseBlackOnly(collectionHandle)) {
      const blacks = _filterHandlesByColor(handles, DEFAULT_COLOR_SLUG);
      if (blacks.length) handles = blacks;
    }

    const saved = _uniq(this._readHandlesForCollection(collectionHandle) || []);
    const picked = saved.filter(h => handles.includes(h));

    const wantN = softDisableAll ? 1 : this.state.maxColumns;
    let active  = picked.slice(0, wantN);
    if (!active.length && handles.length) active = [handles[0]];

    const rest    = handles.filter(h => !active.includes(h));
    const ordered = _uniq([...active, ...rest]);

    this._writeHandles(ordered);
    this._writeHandlesForCollection(collectionHandle, active);
    this.state._disabledHandles = new Set(rest);

    this._syncFromStorage();
    if (this._deferFirstPaint) return;

    await this._ensureData();
    await this._ensureThumbsFor(this._readHandles());
    this._render();
  }

  _handlesEqual(a, b){
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++){
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  async _canonicalizeTrayToDefaultColor(color = DEFAULT_COLOR_SLUG){
    const all = this._filterOutExcluded(this._readHandles());
    if (!all.length) return;

    const seen = new Set();
    const next = [];

    for (const h of all){
      const items = this._getItemsForHandle(h);
      let target = h;

      if (Array.isArray(items) && items.length){
        const byCode   = items.find(i => String(i.color_code || "").toLowerCase() === color);
        const byHandle = items.find(i => _isHandleColor(i.handle, color));
        const pick = byCode || byHandle;
        if (!pick?.handle) continue;
        target = pick.handle;
      } else {
        if (!_isHandleColor(target, color)) continue;
      }

      if (!seen.has(target)) {
        seen.add(target);
        next.push(target);
      }
    }

    const prev = this._readHandles();
    if (this._handlesEqual(prev, next)) return;

    this._suppressCompareChange = true;
    try {
      this._writeHandles(next);
    } finally {
      this._suppressCompareChange = false;
    }

    await this._ensureData();
    await this._ensureThumbsFor(this._readHandles());
    this._render();
  }


  async _fetchCollectionDefaultHandles(collectionHandle) {
    try {
      const all = await this._fetchAllProductHandlesInCollection(collectionHandle);
      const uniq = Array.from(new Set(all)).filter(Boolean);
      const onlyBlack = _filterHandlesByColor(uniq, DEFAULT_COLOR_SLUG);
      return this._filterOutExcluded(onlyBlack);

    } catch (err) {
      log("[compare] fetch defaults (all handles) failed:", err);
      return [];
    }
  }

  async _ensureThumbsFor(handles = []) {
    const all = (handles || []).filter(Boolean);
    if (!all.length || !window.__VPV?.storefront?.q) return;

    const cache = readThumbs();
    const need  = all.map(h => String(h).toLowerCase()).filter(h => !cache[h]);
    if (!need.length) return;

    const CHUNK = 20;
    const chunks = [];
    for (let i = 0; i < need.length; i += CHUNK) chunks.push(need.slice(i, i + CHUNK));

    const addedAll = [];

    for (const group of chunks) {
      const sels = group.map((h, i) => `
        h${i}: product(handle: "${h}") {
          handle
          featuredImage { url(transform: { maxWidth: 800 }) }
        }
      `).join("\n");

      try {
        const data = await window.__VPV?.storefront?.q?.(`query PrimeThumbs { ${sels} }`);
        let changed = false;
        const added = [];

        group.forEach((h, i) => {
          const node = data?.[`h${i}`];
          const handle = String(node?.handle || h || "").toLowerCase();
          const url    = unsizeImage(node?.featuredImage?.url || "");
          if (handle && url && cache[handle] !== url) {
            cache[handle] = url;
            added.push(handle);
            changed = true;
          }
        });

        if (changed) writeThumbs(cache);
        if (added.length) {
          this._patchTrayThumbs(added);
          added.forEach(h => this._patchColumnPrimaryImage(h));
          addedAll.push(...added);
        }
      } catch {}
    }
  }


  _isAttrActiveForProductAny(p, keys, item){
    if (!p || !item) return false;
    const arr = Array.isArray(keys) ? keys.filter(Boolean) : [keys].filter(Boolean);

    for (const k of arr) {
      const ids = (p.metafields_ids && p.metafields_ids[k]) || [];
      if (item.id && ids.includes(item.id)) return true;

      const rawVals = this._valuesFor(p, k);
      if (item.id && rawVals.some(v => this._isGid(v) && v === item.id)) return true;

      const labels = rawVals.map(s => String(s).toLowerCase());
      if (item.label && labels.includes(String(item.label).toLowerCase())) return true;
    }
    return false;
  }

  _getCompareCopy(p) {
    if (!p) return { title: "", description: "" };
    const items = this._getItemsForHandle(p.handle);
    const selHandle = p?.selected?.handle || p?.handle;
    const hit = items.find(i => i.handle === selHandle);
    const title = (hit?.compare_title || p.compare_title || "").trim();
    const description = (hit?.compare_description || p.compare_description || "").trim();
    return { title, description };
  }

  // ---------- utils ----------
  _stripTrailingSlugPart(s) {
    const str = String(s || "").trim();
    if (!/-/.test(str) || /\s/.test(str)) return str;
    return str.replace(/-[^-]+$/, "");
  }

  _slugToLabel(s) {
    return String(s || "").replace(/-/g, " ").replace(/\s+/g, " ").trim();
  }

  _iconUrlFor(p, key){
    if (!p || !key) return '';
    const v = p.metafields && p.metafields[key];
    if (Array.isArray(v)) return v.find(u => typeof u === 'string' && u) || '';
    return typeof v === 'string' ? v : '';
  }

  _dropdownIndex() {
    const fromLS = this._readHandles();
    const set = new Set(fromLS);
    const out = [...fromLS];
    this.state.seedOrder.forEach((h) => { if (!set.has(h)) out.push(h); });
    return out;
  }

  _t(s) { return String(s || "").replace(/[<>]/g, ""); }

  _toArray(val){
    if (val == null) return [];
    if (Array.isArray(val)) return val.filter(v => v != null && v !== '').map(v => String(v));
    if (typeof val === 'string'){
      const s = val.trim();
      if (!s) return [];
      try { const j = JSON.parse(s); if (Array.isArray(j)) return j.map(v => String(v)); } catch {}
      if (s.includes('|')) return s.split('|').map(x => x.trim()).filter(Boolean);
      if (s.includes(',')) return s.split(',').map(x => x.trim()).filter(Boolean);
      return [s];
    }
    if (typeof val === 'object') return [JSON.stringify(val)];
    return [String(val)];
  }

  _valuesFor(p, key){
    if (!key || !p) return [];
    if (p.options && Object.prototype.hasOwnProperty.call(p.options, key)) return this._toArray(p.options[key]);
    if (p.metafields && Object.prototype.hasOwnProperty.call(p.metafields, key)) return this._toArray(p.metafields[key]);
    return [];
  }

  _getItemsForHandle(handle){
    const fromHydrated = this.state.productsByHandle[handle]?.metafields?.[SWATCH_MF_KEY]?.items;
    if (Array.isArray(fromHydrated) && fromHydrated.length) return fromHydrated;
    const fromSeed = this.state.seedByHandle[handle]?.metafields?.[SWATCH_MF_KEY]?.items;
    if (Array.isArray(fromSeed) && fromSeed.length) return fromSeed;
    return [];
  }

  // ---------- NEW: feature hydration helpers ----------
  _normalizeFull(list){

    const arr = _uniq(list);
    const isExcluded = typeof this._isExcluded === "function" ? this._isExcluded.bind(this) : () => false;
    return arr.filter(h => !isExcluded(h));
  }

  _effectiveProductForFeatures(p){
    const sel = p?.selected?.handle;
    if (sel && this.state.productsByHandle[sel]) return this.state.productsByHandle[sel];
    return p;
  }

  _collectFeatureKeys(){
    const mfKeys = [];
    const push = (k)=>{ if(k && !mfKeys.includes(k)) mfKeys.push(k); };
    (this.state.features || []).forEach(f=>{
      push(this._collectionKeyForFeature(f));
      push(f.value);
      push(f.additional_value);
      push(f.metafield_icon);
    });
    return mfKeys;
  }

  async _ensureFeatureDataForHandle(handle){
    if (!handle) return;
    const mfKeys = this._collectFeatureKeys();
    if (!mfKeys.length || !window.__VPV?.storefront?.q) return;

    // Create a shell entry for the selected handle if missing
    if (!this.state.productsByHandle[handle]) {
      // try to find this handle inside any family's swatch items
      let seed = null;
      for (const h in this.state.productsByHandle) {
        const items = this._getItemsForHandle(h);
        const hit = items.find(it => it.handle === handle);
        if (hit) { seed = hit; break; }
      }
      this.state.productsByHandle[handle] = {
        handle,
        title: seed?.title || handle,
        url:   seed?.url   || `/products/${handle}`,
        image: seed?.image || '',
        metafields: {},
        metafields_ids: {}
      };
    }

    const mfSelections = mfKeys.map((key, i) => `
      mf${i}: metafield(namespace: "custom", key: "${key}") {
        type
        value
        reference { __typename ... on MediaImage { image { url } } ... on Metaobject { id } }
        references(first: 10) { edges { node { __typename ... on MediaImage { image { url } } ... on Metaobject { id } } } }
      }
    `).join('\n');

    const data = await window.__VPV?.storefront?.q?.(`
      query($h:String!){
        product(handle:$h){
          id handle
          ${mfSelections}
        }
      }
    `, { h: handle });

    const node = data?.product;
    if (!node) return;

    const isMoGid = s => typeof s === "string" && /^gid:\/\/shopify\/Metaobject\//i.test(s);
    const gidsFromVal = (val) => {
      const out = [];
      if (val == null) return out;
      try {
        const j = JSON.parse(val);
        if (Array.isArray(j)) j.forEach(x => { if (isMoGid(x)) out.push(x); });
        else if (isMoGid(j)) out.push(j);
      } catch {
        String(val).split(/[\s,|]+/).forEach(t => { if (isMoGid(t)) out.push(t); });
      }
      return out;
    };

    const metafields = {};
    const metafieldsIds = {};
    const allMoIds = new Set();

    mfKeys.forEach((k, i) => {
      const mf = node[`mf${i}`];
      if (!mf) return;

      const list = Array.isArray(mf?.references?.edges)
        ? mf.references.edges.map(e => e?.node?.image?.url).filter(Boolean)
        : [];
      const single = mf?.reference?.image?.url || null;
      const val = list.length ? list : (single ?? mf.value ?? null);
      if (val != null) metafields[k] = val;

      const ids = [];
      if (mf?.reference?.__typename === "Metaobject" && mf.reference.id) ids.push(mf.reference.id);
      (mf?.references?.edges || []).forEach(ed => {
        const n = ed?.node;
        if (n?.__typename === "Metaobject" && n.id) ids.push(n.id);
      });
      gidsFromVal(mf.value).forEach(g => ids.push(g));
      if (ids.length) {
        const uniq = Array.from(new Set(ids));
        metafieldsIds[k] = uniq;
        uniq.forEach(id => allMoIds.add(id));
      }
    });

    // Save on the selected product entry
    this.state.productsByHandle[handle].metafields = {
      ...(this.state.productsByHandle[handle].metafields || {}),
      ...metafields
    };
    this.state.productsByHandle[handle].metafields_ids = {
      ...(this.state.productsByHandle[handle].metafields_ids || {}),
      ...metafieldsIds
    };

    await this._resolveMetaobjects([...allMoIds]);
  }

  // ---------- render ----------
  _render() {
    const cols = this.state.columns.slice(0, this.state.maxColumns);
    const max  = this.state.maxColumns;

    // this.innerHTML = `
    //   <div class="compare-products">
    //     ${this._renderTrayFull()}
    //     <div class="compare-products__grid">
    //       ${Array.from({ length: max }).map((_, i) => this._renderColumn(cols[i])).join("")}
    //     </div>
    //   </div>
    // `;

    const $compareProducts = this.querySelector(".compare-products")
    if ($compareProducts) {
      $compareProducts.querySelector(".compare-products__tray")?.remove();
      $compareProducts.insertAdjacentHTML("afterbegin", this._renderTrayFull());
    }

    const $compareProductGrid = this.querySelector(".compare-products__grid")
    if ($compareProductGrid) {
      $compareProductGrid.innerHTML = Array.from({ length: max }).map((_, i) => this._renderColumn(cols[i])).join("")
    }

    const list = this.querySelector(".compare-products__tray-list");
    if (list) {
      // Drag and mobile sort are intentionally removed
      this._bindTrayNav(list);
      //this._bindTraySwipe(list);
      this._bindTrayItemClicks(list);
    }
    this._normalizeFeatureHeights();
    this._ensureTrayCompareCopy(); 
    this._scheduleHeadingSync();
  }

  _renderColumnsOnly(){
    const grid = this.querySelector(".compare-products__grid");
    if (!grid) { this._render(); return; }

    const max  = this.state.maxColumns;
    const cols = this.state.columns.slice(0, max);

    // Ensure we have exactly `max` slots in the grid
    while (grid.children.length < max) grid.insertAdjacentHTML("beforeend", this._renderColumn(undefined));
    while (grid.children.length > max) grid.removeChild(grid.lastElementChild);

    for (let i = 0; i < max; i++) {
      const wantHandle = cols[i];
      const isWantEmpty = !wantHandle || this._isDisabled?.(wantHandle);
      const el = grid.children[i];

      const haveHandle   = el?.getAttribute?.("data-handle") || "";
      const haveIsEmpty  = el?.classList?.contains("is-empty") && !haveHandle;

      // Replace only when slot content changed
      const needsSwap =
        (isWantEmpty && !haveIsEmpty) ||
        (!isWantEmpty && haveHandle !== wantHandle);

      if (needsSwap) {
        el.outerHTML = this._renderColumn(wantHandle);
      }else if (!isWantEmpty && haveHandle === wantHandle) {
       // same handle, but maybe we got new data (features) -> hydrate
       if (this._columnNeedsHydration(el, wantHandle)) {
         el.outerHTML = this._renderColumn(wantHandle);
       }
      }
    }

    this._normalizeFeatureHeights();
    this._scheduleHeadingSync();
  }

  _setTrayItemEnabled(handle, enabled){
    const chip = this.querySelector(`.compare-products__tray-item[data-handle="${handle}"]`);
    if (!chip) return;
    chip.classList.toggle("is-disabled", !enabled);
    chip.classList.toggle("is-active", enabled);

    const removeBtn = chip.querySelector(".compare-products__chip__remove");
    if (enabled && !removeBtn) {
      chip.insertAdjacentHTML("afterbegin", `
        <button type="button" class="compare-products__chip__remove"
          data-remove data-handle="${handle}" aria-label="Remove">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12.4766 12.4758C4.60224 4.6015 3.33398 3.33325 3.33398 3.33325" stroke="#121212" stroke-width="1.5"/>
            <path d="M3.3335 12.4761C11.2076 4.60154 12.4758 3.33325 12.4758 3.33325" stroke="#121212" stroke-width="1.5"/>
          </svg>
        </button>
      `);
    } else if (!enabled && removeBtn) {
      removeBtn.remove();
    }
  }

  _updateThumbCacheFromHydrated(handlesHydrated){
    const thumbs = readThumbs();
    let changed = false;
    handlesHydrated.forEach(h => {
      const p = this.state.productsByHandle[h];
      if (!p) return;
      const url = p.image || "";
      if (url && !thumbs[h]) {
        thumbs[h] = unsizeImage(url);
        changed = true;
      }
    });
    if (changed) {
      writeThumbs(thumbs);
      this._patchTrayThumbs(handlesHydrated);
      handlesHydrated.forEach(h => this._patchColumnPrimaryImage(h));
    }
  }

  _preloadImages(urls = []) {
    urls.forEach((href) => {
      try {
        if (!href) return;
        // evita duplicados
        if ([...document.head.querySelectorAll('link[rel="preload"][as="image"]')]
              .some(l => l.href === href)) return;
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as  = 'image';
        link.href = href;
        document.head.appendChild(link);
      } catch {}
    });
  }


  _renderTrayFull() {
    // Put this first so it's available anywhere below
    const activeCol    = readActiveCollection();
    const activeHandle = activeCol?.handle || null;

    // The working list is already the full tray: [selected..., ...restOfCollection]
    const handles = this._readHandles();

    const titles = readTitles();
    const thumbs = readThumbs();
     try {
       const need = (handles || []).filter(h => {
        const k = String(h || "").toLowerCase();
        return !thumbs[k] && !this.state.seedByHandle[h]?.image;
      });

       if (need.length) this._ensureThumbsFor(need)
     } catch {}
    
     try {
       const top4 = handles.slice(0, 4);
       const urls = top4
         .map(h => unsizeImage(thumbs[h] || (this.state.seedByHandle[h]?.image || "")))
         .filter(Boolean);
       this._preloadImages(urls);
     } catch {}
    const sectionTitle =
      (this.state?.section?.title && this.state.section.title.trim()) ||
      (this.state?.sectionTitle && String(this.state.sectionTitle).trim()) ||
      "Compare";

    const collections = Array.isArray(this.state.collections) && this.state.collections.length
      ? this.state.collections
      : DEFAULT_COMPARE_COLLECTIONS.map(c => ({ ...c, url: `/collections/${c.handle}` }));

    // Build collection chips (uses activeHandle we declared above)
    const collectionChips = collections.map((c) => {
      const t = this._slugToLabel(this._stripTrailingSlugPart(this._t(c.title)));
      const href = c.url || (c.handle ? `/collections/${c.handle}` : "#");
      const isActive = activeHandle && c.handle === activeHandle;
      return `
        <a class="compare-products__tray-active-item${isActive ? " is-active" : ""}"
          role="listitem"
          href="${href}"
          data-handle="${c.handle}"
          data-title="${t}"
          aria-current="${isActive ? "true" : "false"}"
          aria-label="${t}">
          <div class="compare-products__chip__title">${t}</div>
        </a>
      `;
    }).join("");

    // Render tray items from the full working list; active = not disabled
    const items = handles.map((h, i) => {
      const p = this.state.productsByHandle[h] || this.state.seedByHandle[h] || null;
      const key    = String(h || "").toLowerCase();
      const rawImg = thumbs[key] || p?.image || "";

      const img = unsizeImage(rawImg) || ""; // si no hay, dejamos vacío para usar skeleton
      const title = this._slugToLabel(this._stripTrailingSlugPart(this._t(titles[h] || p?.title || h)));
      const copy = p ? this._getCompareCopy(p) : { title: "", description: "" };
      const hasCopy = (copy.title && copy.title.trim()) || (copy.description && copy.description.trim());
      const hoverHTML = hasCopy ? `
        <div class="compare-products__tray-hover" role="tooltip" aria-hidden="true">
          ${copy.title ? `<div class="compare-products__copy-title">${this._t(copy.title)}</div>` : ""}
        </div>
      ` : "";

      if (i < 6) {
        try {
          const k = String(h||"").toLowerCase();
          const p = this.state.productsByHandle[h] || this.state.seedByHandle[h] || null;
          // console.debug('[tray-img]', {
          //   h,
          //   key: k,
          //   hasThumb: !!thumbs[k],
          //   thumb: thumbs[k],
          //   hasSeedImage: !!(p?.image),
          //   seedImage: p?.image,
          //   computedImg: unsizeImage((thumbs[k] || p?.image || "")) || "",
          // });
        } catch {}
      }

      const hasImg = Boolean(img);
      const eager = i < 4;
      const mediaHTML = hasImg
        ? `<img src="${img}" alt="${title}" loading="${eager ? 'eager' : 'lazy'}" decoding="${eager ? 'sync' : 'async'}" fetchpriority="${eager ? 'high' : 'auto'}" draggable="false">`
        : `
          <div class="tray-img-skeleton" aria-hidden="true">
            <span class="vh">Loading image…</span>
          </div>
        `;

      const isEnabled = !this._isDisabled(h);
      const itemClass = isEnabled ? " is-active" : " is-disabled";
      const removeBtn = isEnabled ? `
        <button type="button" class="compare-products__chip__remove"
          data-remove data-handle="${h}" aria-label="Remove ${title}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12.4766 12.4758C4.60224 4.6015 3.33398 3.33325 3.33398 3.33325" stroke="#121212" stroke-width="1.5"/>
            <path d="M3.3335 12.4761C11.2076 4.60154 12.4758 3.33325 12.4758 3.33325" stroke="#121212" stroke-width="1.5"/>
          </svg>
        </button>
      ` : "";

      return `
        <div class="compare-products__tray-item${itemClass}" role="listitem" data-handle="${h}">
          ${removeBtn}
          <div class="compare-products__tray-image${hasImg ? "" : " is-skeleton"}" ${hasImg ? "" : 'aria-busy="true" aria-label="Loading image"'}>
            ${mediaHTML}
            ${hoverHTML}
          </div>
          <div class="compare-products__chip__title">${title}</div>
        </div>
      `;
    }).join("");

    
    return `
      <div class="compare-products__tray" aria-label="Selected products">
        <div class="compare-products__tray-header">
          <h2 class="h3 compare-products__tray-title">${this._t(sectionTitle)}</h2>
          <div class="compare-products__tray-active-products" role="list">
            ${collectionChips}
          </div>
        </div>

        <div class="compare-products__tray-list-wrap">
          <button type="button" class="compare-products__tray-nav is-prev" data-tray-prev aria-label="Scroll left" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4.31028 11.998C17.8244 11.998 20.001 11.998 20.001 11.998" stroke="#121212" stroke-width="2.5"/><path d="M11.5527 20.0007L3.99992 11.9487L11.5527 4.00073" stroke="#121212" stroke-width="2.5"/></svg></button>
          <div class="compare-products__tray-list" role="list" tabindex="-1">
            ${items}
          </div>
          <button type="button" class="compare-products__tray-nav is-next" data-tray-next aria-label="Scroll right" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.6897 12.0034C6.17563 12.0034 3.99902 12.0034 3.99902 12.0034" stroke="#121212" stroke-width="2.5"/><path d="M12.4473 4.00049L20.0001 12.0526L12.4473 20.0005" stroke="#121212" stroke-width="2.5"/></svg></button>
        </div>
      </div>
    `;
  }

  // Enable finger "grab to scroll" on the tray (works with mouse too)
  _bindTraySwipe(list) {
    if (!list) return;

    let isDown = false, dragging = false, moved = false;
    let startX = 0, startLeft = 0, lastX = 0, lastT = 0, velocity = 0, rafId = 0;
    const THRESHOLD = 8; // px before we consider it a drag

    const onDown = (e) => {
      // ignore right/middle clicks
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      isDown = true;
      dragging = false;
      moved = false;

      startX = e.clientX;
      startLeft = list.scrollLeft;
      lastX = startX;
      lastT = performance.now();
      velocity = 0;

      list.setPointerCapture?.(e.pointerId);
    };

    const onMove = (e) => {
      if (!isDown) return;

      const dx = e.clientX - startX;

      // don't start dragging until the pointer moves enough
      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD) return;
        dragging = true;
      }

      moved = true; // we actually dragged

      // drag the scroll position
      list.scrollLeft = startLeft - dx * 1.35;

      // measure velocity for tiny momentum at release
      const now = performance.now();
      const dt = now - lastT;
      if (dt > 0) velocity = (e.clientX - lastX) / dt; // px/ms
      lastX = e.clientX; lastT = now;

      // prevent text selection while dragging
      e.preventDefault();
    };

    const onUp = (e) => {
      if (!isDown) return;
      isDown = false;

      list.releasePointerCapture?.(e.pointerId);

      // simple momentum only if we truly dragged
      if (dragging) {
        let v = velocity * 1600; // px/s
        const decay = 0.97;
        cancelAnimationFrame(rafId);
        const step = () => {
          v *= decay;
          if (Math.abs(v) < 5) return;
          list.scrollLeft -= v / 60;
          rafId = requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }

      dragging = false;
    };

    // swallow click only when a drag actually occurred
    const swallowClick = (e) => {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
      moved = false;
    };

    list.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', onUp);
    list.addEventListener('click', swallowClick, true);
  }

  _bindTrayNav(list) {
    const wrap = list.closest(".compare-products__tray-list-wrap");
    if (!wrap) return;

    const prevBtn = wrap.querySelector("[data-tray-prev]");
    const nextBtn = wrap.querySelector("[data-tray-next]");

    const step = () => {
      const first = list.querySelector(".compare-products__tray-item");
      if (!first) return 240;
      const rect = first.getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap || "0");
      const mr  = parseFloat(getComputedStyle(first).marginRight || "0");
      return Math.ceil(rect.width + gap + mr);
    };

    const update = () => {
      const viewport = list.clientWidth;
      const total    = list.scrollWidth;
      const count    = list.children.length;

      const need   = (count > 4) || (total > viewport + 2);
      wrap.classList.toggle("has-nav", need);

      const atStart = Math.ceil(list.scrollLeft) <= 0;
      const atEnd   = Math.ceil(list.scrollLeft + viewport) >= total - 1;

      prevBtn?.toggleAttribute("disabled", !need || atStart);
      nextBtn?.toggleAttribute("disabled", !need || atEnd);
    };

    const scrollByStep = (dir) => {
      list.scrollBy({ left: dir * step(), behavior: "smooth" });
    };

    prevBtn?.addEventListener("click", () => scrollByStep(-1));
    nextBtn?.addEventListener("click", () => scrollByStep(1));
    list.addEventListener("scroll", update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(list);
    wrap._trayNavRO = ro;

    if (!list._boundCompareClicks) {
      list.addEventListener('click', (e) => {
        const link = e.target.closest('.compare-products__tray-active-item');
        if (!link || !list.contains(link)) return;

        e.preventDefault();

        const nextHandle = (link.dataset.handle || '').toLowerCase();
        const nextTitle  = (link.querySelector('.compare-products__chip__title')?.textContent || link.textContent || '').trim();
        if (!nextHandle) return;

        this._onCollectionChip(nextHandle, nextTitle);

        this.querySelectorAll('.compare-products__tray-active-item').forEach(el=>{
          const on = ((el.dataset.handle || '').toLowerCase() === nextHandle);
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-selected', on ? 'true' : 'false');
          el.tabIndex = on ? 0 : -1;
        });
      }, { passive: false });

      list._boundCompareClicks = true;
    }

    update();
  }

  _bindTrayItemClicks(list) {
    const items = list.querySelectorAll(".compare-products__tray-item");
    items.forEach((el) => {
      if (el._trayClickBound) return;
      el._trayClickBound = true;
      el.addEventListener("click", (e) => {
        if (e.target.closest("[data-remove]")) return;

        e.stopPropagation(); 
        const handle = el.getAttribute("data-handle") || "";
        if (!handle) return;

        this._promoteTrayHandle(handle, { evict: "first" });
        this._headingResizeHandler();
      }, { passive: true });
    });
  }

  _promoteTrayHandle(handle, { evict = "first" } = {}){
    if (!handle) return;

    // Ensure it's in the tray order (usually already is)
    const handles = this._readHandles();
    if (!handles.includes(handle)) {
      handles.push(handle);
      this._writeHandles(handles); // keep global order consistent
    }

    // Enable the clicked one
    this.state._disabledHandles.delete(handle);

    // Compute active -> if over capacity, soft-disable one (not the clicked)
    const active = handles.filter(h => !this._isDisabled(h));
    const over = active.length - this.state.maxColumns;

    let victim = null;
    if (over > 0) {
      const candidates = active.filter(h => h !== handle);
      victim = (evict === "last")
        ? candidates[candidates.length - 1]
        : candidates[0];
      if (victim) this.state._disabledHandles.add(victim);
    }

    // Update tray UI in-place (no full re-render → no flash)
    this._setTrayItemEnabled(handle, true);
    if (victim) this._setTrayItemEnabled(victim, false);
    this._persistActiveSet();
    // Recompute columns and hydrate JUST the grid
    this._syncFromStorage();
    this._ensureData().then(() => this._renderColumnsOnly());
  }


  _renderColumn(handle) {
    if (!handle) {
      return `
        <article class="compare-products__col is-empty">
        <div class="compare-products__heading"><h3 class="compare-products__title"></h3></div>
          <div class="compare-products__empty">
            <div class="compare-products__empty__plus"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 12C6.21951 12 4 12 4 12" stroke="#121212" stroke-width="2.5"/><path d="M12 20C12 6.21951 12 4 12 4" stroke="#121212" stroke-width="2.5"/></svg></div>
            <div class="compare-products__empty__text">Click product above to compare</div>
          </div>
        </article>
      `;
    }

    // If this handle was "soft-removed", keep the slot empty
    if (this.state._disabledHandles.has(handle)) {
      return `
        <article class="compare-products__col is-empty">
        <div class="compare-products__heading"><h3 class="compare-products__title"></h3></div>
          <div class="compare-products__empty">
            <div class="compare-products__empty__plus"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20 12C6.21951 12 4 12 4 12" stroke="#121212" stroke-width="2.5"/><path d="M12 20C12 6.21951 12 4 12 4" stroke="#121212" stroke-width="2.5"/></svg></div>
            <div class="compare-products__empty__text">Click product above to compare</div>
          </div>
        </article>
      `;
    }

    const p = this.state.productsByHandle[handle] || this.state.seedByHandle[handle] || null;
    if (!p) {
      const titles = readTitles();
      const thumbs = readThumbs();
      const guessImg   = unsizeImage(thumbs[handle] || "") || "//cdn.shopify.com/s/images/admin/no-image-large-1.png";
      const url        = `/products/${handle}`;
      const guessTitle = this._t(titles[handle] || this.state.seedByHandle[handle]?.title || handle.replace(/-/g, " ").replace(/\b\w/g, s => s.toUpperCase()));
      return `
        <article class="compare-products__col" data-handle="${handle}">
          <div class="compare-products__heading"><h3 class="compare-products__title">${guessTitle}</h3></div>
          <div class="compare-products__media">
            <a href="${url}" class="compare-products__image" aria-label="${guessTitle}">
              <img src="${guessImg}" loading="lazy" alt="${guessTitle}">
            </a>
          </div>
          <div class="compare-products__cta">
            <a class="btn btn-black" href="${url}">Shop</a>
          </div>
        </article>
      `;

    }

    const selected   = p.selected || null;
    const title      = p.title || handle;
    const url        = selected?.url || p.url || (handle ? `/products/${handle}` : "#");
    const img        = selected?.image || p.image || "//cdn.shopify.com/s/images/admin/no-image-large-1.png";
    const priceNum   = (typeof selected?.price_num === "number" ? selected.price_num : p.price) || 0;
    const compareNum = (typeof selected?.compare_at_num === "number" ? selected.compare_at_num : p.compare_at) || 0;

    const copy = this._getCompareCopy(p);

    const copyHTML = `
      <div class="compare-products__copy">
        <div class="compare-products__copy-title">${this._t(copy.title)}</div>
        <div class="compare-products__copy-desc">${this._t(copy.description)}</div>
      </div>
    `;

    const priceHTML  = (compareNum && compareNum > priceNum)
      ? `Shop now — ${this._money(priceNum)} <s class="compare-price">${this._money(compareNum)}</s>`
      : `Shop now — ${this._money(priceNum)}`;

    return `
      <article class="compare-products__col" data-handle="${handle}">
        <div class="compare-products__heading"><h3 class="compare-products__title">${this._t(title)}</h3></div>
        <div class="compare-products__media">
          <button
            type="button"
            class="compare-products__gallery-nav is-prev"
            data-gallery-prev
            aria-label="Previous image"
          >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4.31003 11.9976C17.8241 11.9976 20.0007 11.9976 20.0007 11.9976" stroke="#121212" stroke-width="2.5"/>
            <path d="M11.5522 20.0005L3.99943 11.9484L11.5522 4.00049" stroke="#121212" stroke-width="2.5"/>
          </svg>
          </button>

          <a href="${url}" class="compare-products__image" aria-label="${this._t(title)}">
            <img src="${img}" loading="lazy" alt="${this._t(title)}">
          </a>

          <button
            type="button"
            class="compare-products__gallery-nav is-next"
            data-gallery-next
            aria-label="Next image"
          >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19.69 12.0034C6.17587 12.0034 3.99927 12.0034 3.99927 12.0034" stroke="#121212" stroke-width="2.5"/>
            <path d="M12.4478 4.00049L20.0006 12.0526L12.4478 20.0005" stroke="#121212" stroke-width="2.5"/>
          </svg>
          </button>

          ${this._renderDash(p)}
        </div>

        ${this._renderSwatches(p)}
        ${copyHTML}
        <div class="compare-products__cta">
          <a class="btn btn-black" href="${url}">${priceHTML}</a>
        </div>
        ${this._renderFeaturesForProduct(p)}
      </article>
    `;
  }

  _onSwatchClick(btn){
    const col = btn.closest(".compare-products__col");
    if (!col) return;

    col.querySelectorAll("[data-swatch]").forEach(b => {
      b.classList.remove("active");
      b.setAttribute("aria-checked", "false");
    });
    btn.classList.add("active");
    btn.setAttribute("aria-checked", "true");

    const nextUrl     = btn.getAttribute("data-url")        || "#";
    const nextImg     = btn.getAttribute("data-img")        || "";
    const nextTitle   = btn.getAttribute("data-title")      || "";
    const nextHandle  = btn.getAttribute("data-handle")     || "";
    const priceNum    = Math.ceil(Number(btn.getAttribute("data-price-num")   || 0));
    const compareNum  = Math.ceil(Number(btn.getAttribute("data-compare-num") || 0));
    const colorName   = btn.getAttribute("data-color")      || "";

    const handle    = col.getAttribute("data-handle") || "";
    const mediaLink = col.querySelector(".compare-products__media a.compare-products__image");
    const mediaImg  = col.querySelector(".compare-products__media img");
    const topCta    = col.querySelector(".compare-products__cta a");
    const bottomCta = this.querySelector(`[data-cta][data-handle="${handle}"]`);
    const labelEl   = col.querySelector(".compare-products__swatches__name__value");

    const priceHTML = (compareNum && compareNum > priceNum)
      ? `Shop now — ${this._money(priceNum)} <s class="compare-price">${this._money(compareNum)}</s>`
      : `Shop now — ${this._money(priceNum)}`;

    if (mediaLink) mediaLink.setAttribute("href", nextUrl);
    if (mediaImg) {
      mediaImg.removeAttribute("srcset");
      mediaImg.removeAttribute("data-srcset");
      mediaImg.setAttribute("src", nextImg);
      mediaImg.setAttribute("alt", this._t(nextTitle));
      mediaImg.setAttribute("decoding", "async");
      mediaImg.setAttribute("fetchpriority", "high");
    }
    // warm preload around current gallery index (after swatch change we reset to 0 below)
    const active = (this.state.productsByHandle[handle]?.selected?.handle || handle || "").trim();
    this._ensureGalleryForHandle(active).then((g) => {
      if (!Array.isArray(g) || !g.length) return;
      const curr = (typeof this.state.productsByHandle[handle]?.selected?.gallery_idx === "number")
        ? this.state.productsByHandle[handle].selected.gallery_idx
        : 0;
      const prev = (curr - 1 + g.length) % g.length;
      const next = (curr + 1) % g.length;
      this._preloadImages([g[prev], g[next]]);
    });

    if (labelEl && colorName) labelEl.textContent = colorName;

    const target = handle && this.state.productsByHandle[handle];
    if (target) {
      target.selected = {
        handle: nextHandle,
        url: nextUrl,
        image: nextImg,
        title: nextTitle,
        price_num: priceNum,
        compare_at_num: compareNum,
        gallery_idx: 0
      };
    }

    if (topCta) { topCta.setAttribute("href", nextUrl); topCta.innerHTML = priceHTML; }
    if (bottomCta) { bottomCta.setAttribute("href", nextUrl); bottomCta.innerHTML = priceHTML; }

    // Update compare copy for the newly selected color
    const product = this.state.productsByHandle[handle];
    const c = this._getCompareCopy(product);

    const wrap   = col.querySelector(".compare-products__copy");
    const titleEl= wrap?.querySelector(".compare-products__copy-title");
    const descEl = wrap?.querySelector(".compare-products__copy-desc");

    if (wrap && titleEl && descEl) {
      titleEl.textContent = c.title || "";
      descEl.textContent  = c.description || "";
      wrap.style.display  = (c.title || c.description) ? "" : "none";
    }

    // Re-render the dash using the new color's gallery (lazy fetch if needed)
    const activeHandle = (product?.selected?.handle || product?.handle || "").trim();
    this._ensureGalleryForHandle(activeHandle).then((gallery) => {
      // Rebuild just the dash container for this column
      const media = col?.querySelector(".compare-products__media");
      if (media) {
        const oldDash = media.querySelector(".compare-products__dash-container");
        if (oldDash) oldDash.outerHTML = this._renderDash(product);
      }
      // Light warmup for the new color
      if (Array.isArray(gallery) && gallery.length) {
        this._preloadImages(gallery.slice(0, 2));
      }
    });

    // NEW: hydrate features for selected swatch & re-render feature stack
    this._ensureFeatureDataForHandle(nextHandle).then(() => {
      const baseProduct = this.state.productsByHandle[handle];
      const colEl = this.querySelector(`.compare-products__col[data-handle="${handle}"]`);
      if (!colEl) return;
      const featuresEl = colEl.querySelector(".compare-products__features-stack");
      if (featuresEl) {
        featuresEl.outerHTML = this._renderFeaturesForProduct(baseProduct);
        this._normalizeFeatureHeights();
        this._scheduleHeadingSync();
      }
    });
  }

  _renderSwatches(p) {
    const items = this._getItemsForHandle(p?.handle);
    if (!Array.isArray(items) || !items.length) return "";

    const slugFrom = (it) => {

      if (it?.handle) return String(it.handle);
      const u = String(it?.url || "");
      const m = u.match(/\/products\/([^/?#]+)/i);
      if (m) return m[1];
      try {
        const url = new URL(u, location.origin);
        const parts = url.pathname.split("/").filter(Boolean);
        const i = parts.indexOf("products");
        return i >= 0 ? parts[i + 1] || "" : "";
      } catch { return ""; }
    };
    const toks = (s) => String(s || "").split("-").filter(Boolean);
    const humanize = (s) => String(s || "").replace(/-/g, " ").replace(/\b\w/g, m => m.toUpperCase());

    const slugs = items.map(slugFrom);
    const tokenized = slugs.map(toks);

    let prefixTokens = [];
    if (items.length > 1) {
      const threshold = Math.max(2, Math.ceil(items.length * 0.6));
      for (let i = 0; ; i++) {
        const counts = new Map();
        let sawToken = false;
        tokenized.forEach(arr => {
          const token = arr?.[i];
          if (!token) return;
          sawToken = true;
          counts.set(token, (counts.get(token) || 0) + 1);
        });
        if (!sawToken || !counts.size) break;
        const [candidate, freq] = Array.from(counts.entries()).sort((a, b) => b[1] - a[1])[0];
        if (freq < threshold) break;
        prefixTokens.push(candidate);
      }
    } else {
      const owner = toks(p?.handle);
      const only = tokenized[0] || [];
      let i = 0; while (i < only.length && i < owner.length && only[i] === owner[i]) i++;
      prefixTokens = only.slice(0, i);
    }

    const slugify = (value) => {
      const str = String(value || "").trim().toLowerCase();
      const normalized = typeof str.normalize === "function" ? str.normalize("NFD") : str;
      return normalized
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    };

    let baseTokens = prefixTokens.slice();
    const maybeExtendBaseTokens = (source) => {
      if (!source) return;
      const slugged = slugify(source);
      if (!slugged) return;
      const tokens = toks(slugged);
      if (!tokens.length) return;
      if (!baseTokens.length) {
        baseTokens = tokens.slice();
        return;
      }
      const matchesPrefix = baseTokens.every((tok, idx) => tokens[idx] === tok);
      if (!matchesPrefix) return;
      for (let idx = baseTokens.length; idx < tokens.length; idx++) {
        baseTokens.push(tokens[idx]);
      }
    };

    maybeExtendBaseTokens(p?.title);
    maybeExtendBaseTokens(items?.[0]?.title);
    maybeExtendBaseTokens(p?.compare_title);
    maybeExtendBaseTokens(items?.[0]?.compare_title);

    if (!baseTokens.length) {
      baseTokens = prefixTokens.slice();
    }

    const colorFromSlug = (slug) => {
      const parts = toks(slug);
      let consume = 0;
      while (consume < baseTokens.length && consume < parts.length) {
        if (parts[consume] !== baseTokens[consume]) break;
        consume++;
      }
      const out = parts.slice(consume).join("-");
      return out || parts.slice(-1)[0] || "";
    };

    let activeIdx = items.findIndex(it => it.handle === (p?.selected?.handle || p?.handle));
    if (activeIdx < 0) activeIdx = 0;

    const activeSlug = slugs[activeIdx] || "";
    const activeColorName = humanize(colorFromSlug(activeSlug));

    const mobileMaxSwatchesPerRow = 6;
    const desktopMaxSwatchesPerRow = 10;
    let breakLine = false;
    if (window.innerWidth <= 410) {
      breakLine = items.length > mobileMaxSwatchesPerRow - 1;
    } else if (window.innerWidth <= 700) {
      breakLine = items.length > mobileMaxSwatchesPerRow;
    } else {
      breakLine = items.length > desktopMaxSwatchesPerRow;
    }

    const btn = (it, i) => {
      const slug      = slugs[i] || "";
      const colorSlug = colorFromSlug(slug);
      const colorName = humanize(colorSlug);
      const isActive  = i === activeIdx;
      const priceTxt  = this._money(it.price_num || 0);
      const style     = it.color_code ? `style="border-color:${it.color_code};background-color:${it.color_code}"` : "";
      const label     = `${this._t(it.title)}${colorName ? " — " + this._t(colorName) : ""}`;

      return `
        <button
          type="button"
          role="radio"
          aria-checked="${isActive ? "true" : "false"}"
          aria-label="${label}"
          class="compare-products__swatch ${isActive ? "active" : ""}"
          data-swatch
          data-title="${this._t(it.title)}"
          data-handle="${it.handle}"
          data-url="${it.url}"
          data-img="${it.image}"
          data-price="${priceTxt}"
          data-price-num="${Number(it.price_num || 0)}"
          data-compare-num="${Number(it.compare_at_num || 0)}"
          data-color="${this._t(colorName)}"
          ${style}
        ></button>
      `;
    };

    return `
      <div class="compare-products__swatches" role="radiogroup" aria-label="Choose color">
        <div class="compare-products__swatches__name">
          Color: <span class="compare-products__swatches__name__value">${this._t(activeColorName)}</span>
        </div>
        <div class="compare-products__swatches__buttons${breakLine ? " has-break" : ""}">
          ${items.map(btn).join("")}
        </div>
      </div>
    `;
  }

  _renderDash(p) {
    const maxToShow = 8;
    if (!p) return "";

    const activeHandle = (p.selected?.handle || p.handle || "").trim();
    const gallery = this._getGalleryForHandle(activeHandle);

    if (!Array.isArray(gallery) || !gallery.length) return "";

    const firstN = gallery.slice(0, maxToShow);

    const dash = (_url, i) => {
      const isActive = (typeof p.selected?.gallery_idx === "number")
        ? (i === p.selected.gallery_idx)
        : (i === 0);
      return `
        <button
          type="button"
          class="compare-products__dash ${isActive ? "active" : ""}"
          data-gallery-idx="${i}"
          aria-current="${isActive ? "true" : "false"}"
          aria-label="Show image ${i + 1}"
        >
        </button>
      `;
    };

    return `
      <div class="compare-products__dash-container" role="list" aria-label="Gallery images">
        ${firstN.map(dash).join("")}
      </div>
    `;
  }

  _renderFeaturesForProduct(p) {
    if (!p || !this.state.features?.length) {
      return `<section class="compare-products__features-stack is-empty" aria-hidden="true"></section>`;
    }

    // Evaluate features against the selected swatch's product when present
    const px = this._effectiveProductForFeatures(p);

    const section = (f) => {
      if (!this._hasDataForFeature(px, f)) return "";
      const titleText = String(f.title || "");
      const keyLower  = titleText.trim().toLowerCase();

      const sectionIconUrl = this._iconUrlFor(px, f.metafield_icon);

      if (keyLower === "warmth") {
        const rawValArr = this._valuesFor(px, f.value);
        const first     = rawValArr[0];

        if (first == null || String(first).trim() === "") return "";

        const [valFromPair, maxFromPair] = this._parseMeterPair(first);

        const addArr      = this._valuesFor(px, f.additional_value);
        const explicitMax = parseInt(addArr[0], 10);
        const fallbackMax = Number.isFinite(Number(f?.max)) ? Number(f.max) : 8;

        const max   = maxFromPair || (Number.isFinite(explicitMax) ? explicitMax : fallbackMax);
        const value = Math.min(valFromPair || 0, max);

        return `
          <div class="compare-products__feature compare-products__feature--warmth">
            <div class="compare-products__feature-title">${this._t(titleText)}</div>
            <div class="compare-products__feature-body">
              ${sectionIconUrl ? `<img class="compare-products__cell__icon" alt="${this._t(titleText)} Icon" src="${sectionIconUrl}">` : ""}
              ${this._renderBarMeter(value, max, titleText || "level")}
              ${f.information ? `<div class="compare-products__cell__information">${this._t(f.information)}</div>` : ""}
            </div>
          </div>
        `;
      }

      const collectionKey = this._collectionKeyForFeature(f);
      const catalogItems  = this._getCollectionItems(collectionKey);

      if (Array.isArray(catalogItems) && catalogItems.length) {
        const keysToCheck = Array.from(new Set([
          ...this._synonymKeys(collectionKey),
          ...this._synonymKeys(f.value),
          f.additional_value
        ].filter(Boolean)));

        const itemsHtml = catalogItems.map(it => {
          const on = this._isAttrActiveForProductAny(px, keysToCheck, it);
          return `
            <div class="compare-pill ${on ? "is-active" : "is-inactive"}">
              ${it.label ? `<span class="compare-pill__label">${this._t(it.label)}</span>` : ""}
              ${it.icon  ? `<img class="compare-pill__icon" src="${it.icon}" alt="" aria-hidden="true">` : ""}
            </div>
          `;
        }).join("");

        return `
          <div class="compare-products__feature">
            <div class="compare-products__feature-title">${this._t(String(f.title || ""))}</div>
            <div class="compare-products__feature-body">
              ${sectionIconUrl ? `<img class="compare-products__cell__icon" alt="" src="${sectionIconUrl}">` : ""}
              <div class="compare-products__pills">${itemsHtml}</div>
              ${f.information ? `<div class="compare-products__cell__information">${this._t(f.information)}</div>` : ""}
            </div>
          </div>
        `;
      }

      const productKey = collectionKey || f.value;
      const selectedObjs = this._getMetaobjectsForProduct(px, productKey);

      if (selectedObjs.length) {
        const itemsHtml = selectedObjs.map(it => `
          <div class="compare-pill is-active">
            ${it.label ? `<span class="compare-pill__label">${this._t(it.label)}</span>` : ""}
            ${it.icon  ? `<img class="compare-pill__icon" src="${it.icon}" alt="" aria-hidden="true">` : ""}
          </div>
        `).join("");

        return `
          <div class="compare-products__feature">
            <div class="compare-products__feature-title">${this._t(titleText)}</div>
            <div class="compare-products__feature-body">
              ${sectionIconUrl ? `<img class="compare-products__cell__icon" alt="${this._t(titleText)} Icon" src="${sectionIconUrl}">` : ""}
              <div class="compare-products__pills">${itemsHtml}</div>
              ${f.information ? `<div class="compare-products__cell__information">${this._t(f.information)}</div>` : ""}
            </div>
          </div>
        `;
      }

      const valsAll    = this._valuesFor(px, f.value).filter(v => !this._isGid(v));
      const addValsAll = this._valuesFor(px, f.additional_value).filter(v => !this._isGid(v));

      // If both primary and additional are empty → hide section
      if (!valsAll.length && !addValsAll.length) return "";

      const html = valsAll.map(v => `<p class="compare-products__feature-item">${this._t(v)}</p>`).join("");
      const addHtml = addValsAll.map(v => `<p class="compare-products__feature-item compare-products__feature-item--secondary">${this._t(v)}</p>`).join("");

      return `
        <div class="compare-products__feature">
          <div class="compare-products__feature-title">${this._t(titleText)}</div>
          <div class="compare-products__feature-body">
            ${sectionIconUrl ? `<img class="compare-products__cell__icon" alt="${this._t(titleText)} Icon" src="${this._iconUrlFor(px, f.metafield_icon)}">` : ""}
            ${html ? `<div class="compare-products__cell__head">${html}</div>` : ""}
            ${addHtml ? `<div class="compare-products__cell__additional">${addHtml}</div>` : ""}
            ${f.information ? `<div class="compare-products__cell__information">${this._t(f.information)}</div>` : ""}
          </div>
        </div>
      `;

    };

    const rendered = this.state.features.map(section).filter(Boolean).join("");
    if (!rendered.trim()) {
      return `<section class="compare-products__features-stack is-empty" aria-hidden="true"></section>`;
    }

    return `
      <section class="compare-products__features-stack" aria-label="Features">
        ${rendered}
      </section>
    `;
  }

  _normalizeFeatureHeights(){
    // measure after layout paints
    requestAnimationFrame(() => {
      const stacks = [...this.querySelectorAll('.compare-products__features-stack')];
      if (!stacks.length) return;

      // get tallest real (non-empty) stack
      const maxH = stacks
        .filter(el => !el.classList.contains('is-empty'))
        .reduce((m, el) => Math.max(m, el.getBoundingClientRect().height), 0);

      // apply same min-height to empties only
      stacks.forEach(el => {
        if (el.classList.contains('is-empty')) {
          el.style.minHeight = (maxH || 0) + 'px';
        } else {
          el.style.minHeight = ''; // reset if content exists
        }
      });
    });
  }

  _scheduleHeadingSync(){
    if (this._headingRaf) cancelAnimationFrame(this._headingRaf);
    this._headingRaf = requestAnimationFrame(() => {
      this._headingRaf = null;
      this._syncHeadingHeights();
    });
  }

  _syncHeadingHeights(){
    const grid = this.querySelector(".compare-products__grid");
    if (!grid) return;

    grid.style.removeProperty("--compare-heading-height");

    const headings = Array.from(grid.querySelectorAll(".compare-products__heading"));
    if (!headings.length) return;

    const max = headings.reduce((acc, el) => {
      if (!el || !el.isConnected) return acc;
      const rect = el.getBoundingClientRect();
      return Math.max(acc, rect.height);
    }, 0);

    if (!max) return;

    grid.style.setProperty("--compare-heading-height", `${Math.ceil(max)}px`);
  }

  // propagate swatches across a "family" of handles
  _propagateSwatchesAcrossFamily(){
    const map = {};

    const collectFrom = (obj) => {
      Object.values(obj || {}).forEach(p => {
        const items = p?.metafields?.[SWATCH_MF_KEY]?.items;
        if (Array.isArray(items) && items.length) {
          map[p.handle] = items;
          items.forEach(it => { if (it?.handle) map[it.handle] = items; });
        }
      });
    };
    collectFrom(this.state.productsByHandle);
    collectFrom(this.state.seedByHandle);

    const applyTo = (obj) => {
      Object.keys(obj || {}).forEach(h => {
        const p = obj[h];
        const has = p?.metafields?.[SWATCH_MF_KEY]?.items?.length;
        const src = map[h];
        if (!has && Array.isArray(src) && src.length) {
          p.metafields = p.metafields || {};
          p.metafields[SWATCH_MF_KEY] = { items: src };
        }
      });
    };
    applyTo(this.state.productsByHandle);
    applyTo(this.state.seedByHandle);
  }

  _renderBarMeter(value, max, label = "level") {
    const v = Math.max(0, Math.min(Number(value || 0), Number(max || 0)));
    const m = Math.max(0, Number(max || 0));
    const bars = Array.from({ length: m }, (_, i) =>
      `<span class="compare-products__meter__bar${i < v ? " is-filled" : ""}" aria-hidden="true"></span>`
    ).join("");
    return `
      <div class="compare-products__meter" role="img"
          aria-label="${label}: ${v} of ${m}">
        ${bars}
      </div>
    `;
  }

  _parseMeterPair(valueMaybePair) {
    if (valueMaybePair == null) return [0, 0];
    const s = String(valueMaybePair).trim();
    if (/^\d+\s*\/\s*\d+$/.test(s)) {
      const [a, b] = s.split('/').map(n => parseInt(n, 10));
      return [Number.isFinite(a) ? a : 0, Number.isFinite(b) ? b : 0];
    }
    const n = parseInt(s, 10);
    return [Number.isFinite(n) ? n : 0, 0];
  }

  disconnectedCallback() {
    //window.removeEventListener("compare_change", this._onCompareChange);
    window.removeEventListener("storage", this._onStorage);
    this.removeEventListener("click", this._onRootClick);
    this._ro?.disconnect();
    if (this._mqHandler) window.removeEventListener('resize', this._mqHandler);
    if (this._headingResizeHandler) window.removeEventListener('resize', this._headingResizeHandler);
    if (this._fontListener && document?.fonts?.removeEventListener) {
      document.fonts.removeEventListener('loadingdone', this._fontListener);
      this._fontListener = null;
    }
    if (this._headingRaf) {
      cancelAnimationFrame(this._headingRaf);
      this._headingRaf = null;
    }
  }
}

customElements.define("compare-products", CompareProducts);
